const fr = {
  // Navigation
  nav: {
    products: 'Produits SaaS',
    software: 'Logiciels',
    services: 'Services',
    pricing: 'Tarifs',
    resources: 'Ressources',
    about: 'À propos',
    contact: 'Contact',
    login: 'Connexion',
    getStarted: 'Commencer',
    cmms: 'GMAO',
    cmmsDesc: 'Système de Gestion de Maintenance',
    chatbot: 'Chatbot IA',
    chatbotDesc: 'Automatisation du Support Client',
    sfms: 'SFMS',
    sfmsDesc: 'Système de Gestion des Installations Sportives',
    gms: 'GMS',
    gmsDesc: 'Système de Gestion de Salle de Sport',
    digitalTransformation: 'Transformation Numérique',
    digitalTransformationDesc: 'Conseil & Stratégie',
    customDevelopment: 'Développement Personnalisé',
    customDevelopmentDesc: 'Solutions Logicielles Sur Mesure',
    blog: 'Blog',
    blogDesc: 'Articles & Insights',
    docs: 'Documentation',
    docsDesc: 'Guides Produits',
    help: "Centre d'Aide",
    helpDesc: 'FAQ & Support',
    caseStudies: 'Études de Cas',
    caseStudiesDesc: 'Histoires de Succès',
  },

  // Hero Section
  hero: {
    badge: 'Approuvé par des entreprises dans le monde',
    headline1: 'Transformez Votre Entreprise avec',
    headline2: 'Des Solutions Intelligentes',
    subheadline: "Plateforme SaaS d'entreprise offrant GMAO, chatbots IA, conseil en transformation numérique et développement logiciel sur mesure.",
    feature1: 'Assistance à la configuration incluse',
    feature2: 'Formules mensuelles ou annuelles',
    feature3: 'Annulez à tout moment',
    ctaPrimary: 'Commencer',
    ctaSecondary: 'Voir la Démo',
    trustedBy: 'Approuvé par les entreprises leaders',
  
},

  // Products
  products: {
    title1: 'Nos',
    title2: 'Produits SaaS',
    subtitle: 'Choisissez parmi nos puissantes solutions SaaS conçues pour résoudre les défis commerciaux réels',
    cmmsTitle: 'GMAO',
    cmmsSubtitle: 'Système de Gestion de Maintenance',
    cmmsDesc: "Rationalisez vos opérations de maintenance avec notre solution GMAO complète. Suivez les actifs, gérez les ordres de travail et optimisez les calendriers de maintenance préventive.",
    cmmsFeature1: 'Suivi et gestion des actifs',
    cmmsFeature2: 'Automatisation des ordres de travail',
    cmmsFeature3: 'Planification de la maintenance préventive',
    cmmsFeature4: 'Gestion des stocks',
    cmmsFeature5: 'Tableaux de bord et analyses en temps réel',
    cmmsFeature6: 'Application mobile pour les techniciens',
    cmmsPrice: 'À partir de 99 $/mois',
    chatbotTitle: 'Chatbot IA',
    chatbotSubtitle: 'Automatisation du Support Client',
    chatbotDesc: "Déployez des chatbots IA intelligents qui fournissent un support client 24/7. Entraînez-les sur vos documents et le contenu de votre site pour des réponses précises et contextuelles.",
    chatbotFeature1: 'Traitement du langage naturel',
    chatbotFeature2: 'Formation sur documents et sites web',
    chatbotFeature3: 'Support multilingue',
    chatbotFeature4: 'Analyses des conversations',
    chatbotFeature5: 'Intégration facile au site web',
    chatbotFeature6: 'Apparence personnalisable',
    chatbotFeature7: 'Transfert à un agent humain en direct',
    chatbotPrice: 'À partir de 49 $/mois',
    startingAt: 'À partir de',
    learnMore: 'En savoir plus',
    viewPricing: 'Voir tous les plans et tarifs',
  },

  // Services
  services: {
    title1: 'Services',
    title2: 'Professionnels',
    subtitle: "Conseil d'experts et développement sur mesure pour accélérer votre parcours numérique",
    dtTitle: 'Conseil en Transformation Numérique',
    dtDesc: "Transformez votre entreprise avec nos services de conseil experts. Nous vous aidons à exploiter la technologie pour optimiser les opérations, améliorer l'expérience client et stimuler la croissance.",
    dtCap1: 'Stratégie & Feuille de route',
    dtCap2: 'Automatisation des processus',
    dtCap3: 'Gestion du changement',
    dtDeliverTitle: 'Ce que nous livrons :',
    dtDeliver1: 'Évaluation technologique complète',
    dtDeliver2: 'Développement de stratégie numérique et feuille de route',
    dtDeliver3: 'Optimisation des processus et automatisation',
    dtDeliver4: 'Support à la gestion du changement',
    dtDeliver5: 'Analyse du ROI et suivi des KPI',
    dtCta: 'Planifier une consultation gratuite',
    dtPrice: 'Tarification personnalisée selon la portée',
    cdTitle: "Développement d'Applications Sur Mesure",
    cdDesc: "Obtenez des solutions logicielles sur mesure conçues spécifiquement pour les besoins de votre entreprise. Notre équipe d'experts livre des applications web et mobiles de haute qualité avec les technologies modernes.",
    cdCap1: 'Développement Full-Stack',
    cdCap2: 'Méthodologie Agile',
    cdCap3: 'Assurance Qualité',
    cdDeliver1: "Développement d'applications web et mobiles",
    cdDeliver2: "Développement et intégration d'API",
    cdDeliver3: 'Modernisation des systèmes legacy',
    cdDeliver4: "Configuration de l'infrastructure cloud",
    cdDeliver5: 'Support et maintenance continus',
    cdCta: 'Demander un devis de projet',
    cdPrice: '',
    projects: 'Projets',
    satisfaction: 'Satisfaction',
    support: 'Support',
    notSure: 'Vous ne savez pas quel service correspond à vos besoins ?',
    notSureDesc: 'Planifiez une consultation gratuite et laissez nos experts vous guider',
    contactUs: "Contactez-nous aujourd'hui",
  },

  // Features
  features: {
    title1: 'Pourquoi Choisir',
    title2: 'mwbTechs',
    subtitle: "Fonctionnalités de niveau entreprise conçues pour les entreprises modernes",
    security: 'Sécurité Entreprise',
    securityDesc: "Chiffrement de niveau bancaire, conformité SOC 2 et audits de sécurité réguliers pour protéger vos données.",
    fast: 'Ultra Rapide',
    fastDesc: "Performances optimisées avec garantie de disponibilité 99,9% et temps de réponse inférieurs à la seconde.",
    collaboration: "Collaboration d'Équipe",
    collaborationDesc: "Contrôle d'accès basé sur les rôles, mises à jour en temps réel et communication d'équipe fluide.",
    analytics: 'Analyses Avancées',
    analyticsDesc: 'Tableaux de bord complets, rapports personnalisés et insights basés sur les données pour de meilleures décisions.',
    multiLanguage: 'Multilingue',
    multiLanguageDesc: 'Support de plusieurs langues avec traduction automatique et fonctionnalités de localisation.',
    privacy: 'Confidentialité des Données',
    privacyDesc: 'Conforme au RGPD, options de résidence des données et contrôle total sur vos informations.',
    support247: 'Support 24/7',
    support247Desc: 'Support client 24h/24 via chat, e-mail et téléphone avec temps de réponse < 2 heures.',
    mobile: 'Applications Mobiles',
    mobileDesc: 'Applications iOS et Android pour un accès en déplacement depuis n\'importe quel appareil.',
    customers: 'Clients Actifs',
    uptime: 'SLA de Disponibilité',
    users: 'Utilisateurs Quotidiens',
    supportAvailable: 'Support Disponible',
  },

  // Pricing
  pricing: {
    title1: 'Tarification',
    title2: 'Simple et Transparente',
    subtitle: "Choisissez la formule idéale pour votre entreprise.",
    monthly: 'Mensuel',
    annual: 'Annuel',
    save: 'Économisez 20%',
    cmmsPlans: 'Plans GMAO',
    chatbotPlans: 'Plans Chatbot IA',
    basic: 'Basique',
    pro: 'Pro',
    enterprise: 'Entreprise',
    popular: 'Le Plus Populaire',
    perMonth: '/mois',
    billedAnnually: 'facturé annuellement',
    startTrial: 'Commencer',
    contactSales: 'Contacter les Ventes',
    viewDetailed: 'Voir les Tarifs et Fonctionnalités Détaillés',
    extraSlots: 'Des licences supplémentaires peuvent être achetées séparément',
    extraMessages: 'Des messages supplémentaires peuvent être achetés séparément',
    extraMessagesRate: 'Messages supplémentaires : {{price}} $ pour 1 000',
  

    feat_unlimitedAssets: 'Actifs illimités',
    feat_assets: '{{n}} actifs',
    feat_unlimitedUsers: 'Utilisateurs illimités',
    feat_users: '{{n}} utilisateurs',
    feat_unlimitedLocations: 'Sites illimités',
    feat_locations: '{{n}} sites',
    feat_unlimitedBranches: 'Succursales illimitées',
    feat_branches: '{{n}} succursales',
    feat_unlimitedMsgs: 'Messages illimités/mois',
    feat_msgs: '{{n}} messages/mois',
    feat_unlimitedChatbots: 'Chatbots illimités',
    feat_chatbots: '{{n}} chatbots',
    feat_chatbot: '{{n}} chatbot',
    feat_unlimitedDocs: 'Documents illimités par chatbot',
    feat_docs: '{{n}} documents par chatbot',
    feat_doc: '{{n}} document par chatbot',
    feat_agents: '{{n}} agents en direct inclus',
    feat_agent: '{{n}} agent en direct inclus',
    feat_channels: 'WhatsApp, Instagram & Facebook',
    descBasicCmms: 'Parfait pour les petites équipes',
    descProCmms: 'Le plus populaire pour les entreprises en croissance',
    descEnterpriseCmms: 'Pour les grandes organisations',
    descBasicChatbot: 'Idéal pour les petits sites web',
    descProChatbot: 'Idéal pour les entreprises en croissance',
    descEnterpriseChatbot: 'Pour une utilisation à fort volume',
    feat_workOrders: 'Gestion des ordres de travail',
    feat_basicReports: 'Rapports de base',
    feat_emailSupport: 'Support par e-mail',
    feat_mobileApp: 'Accès via l\'application mobile',
    feat_advWorkOrders: 'Ordres de travail avancés',
    feat_preventive: 'Maintenance préventive',
    feat_inventory: 'Gestion des stocks',
    feat_prioritySupport: 'Support prioritaire',
    feat_customReports: 'Rapports personnalisés',
    feat_apiAccess: 'Accès API',
    feat_allPro: 'Toutes les fonctionnalités Pro',
    feat_customInteg: 'Intégrations personnalisées',
    feat_dedicatedMgr: 'Responsable de compte dédié',
    feat_phone247: 'Support téléphonique 24/7',
    feat_advSecurity: 'Sécurité avancée',
    feat_sla: 'Garantie SLA',
    feat_1website: '1 exploration de site web',
    feat_websites: '{{n}} explorations de sites web',
    feat_basicAnalytics: 'Analyses de base',
    feat_advAnalytics: 'Analyses avancées',
    feat_customBranding: 'Marque personnalisée',
    feat_unlimMsgs: 'Messages illimités',
    feat_unlimDocs: 'Documents illimités',
    feat_unlimCrawls: 'Explorations illimitées',
    feat_support247: 'Support 24/7',
    feat_whiteLabel: 'Solution white-label',
},

  // Testimonials
  testimonials: {
    title1: 'Aimé par',
    title2: 'les Clients du Monde Entier',
    subtitle: 'Découvrez ce que nos clients disent de leur expérience',
    trustedBy: 'Approuvé par les marques leaders dans le monde entier',
  },

  // CTA
  cta: {
    title: 'Prêt à Transformer Votre Entreprise ?',
    subtitle: 'Rejoignez les entreprises qui font confiance à mwbTechs pour leur transformation numérique',
    feature1: 'Facturation mensuelle ou annuelle',
    feature2: 'Support prioritaire',
    feature3: 'Annulez à tout moment',
    feature4: 'Assistance à la configuration incluse',
    startTrial: 'Commencer',
    talkToSales: 'Parler aux Ventes',
    companies: 'Entreprises',
    activeUsers: 'Utilisateurs Actifs',
    uptime: 'Disponibilité',
    support: 'Support',
  },

  // Footer
  footer: {
    description: "Plateforme SaaS d'entreprise offrant des solutions innovantes pour les entreprises modernes. Transformez vos opérations avec notre technologie de pointe.",
    products: 'Produits',
    software: 'Logiciels',
    services: 'Services',
    resources: 'Ressources',
    company: 'Entreprise',
    newsletter: 'Abonnez-vous à notre newsletter',
    newsletterDesc: 'Recevez les dernières mises à jour, nouvelles et offres exclusives dans votre boîte de réception.',
    emailPlaceholder: 'Entrez votre e-mail',
    subscribe: "S'abonner",
    subscribeSuccess: "Merci de votre abonnement ! Vérifiez votre boîte de réception pour l'e-mail de confirmation.",
    subscribeError: 'Une erreur est survenue. Veuillez réessayer.',
    copyright: 'mwbTechs. Tous droits réservés.',
    linkCmms: 'GMAO',
    linkChatbot: 'Chatbot IA',
    linkSfms: 'SFMS',
    linkGms: 'GMS',
    linkPricing: 'Tarifs',
    linkDigitalTransformation: 'Transformation Numérique',
    linkCustomDevelopment: 'Développement Sur Mesure',
    linkDocumentation: 'Documentation',
    linkHelpCenter: "Centre d'Aide",
    linkCaseStudies: 'Études de Cas',
    linkAboutUs: 'À Propos',
    linkContact: 'Contact',
    linkPrivacy: 'Politique de Confidentialité',
    linkTerms: 'Conditions d\'Utilisation',
    linkSecurity: 'Sécurité',
  },

  // Contact
  contact: {
    title1: 'Entrer en',
    title2: 'Contact',
    subtitle: "Vous avez une question ou êtes prêt à démarrer votre projet ? Nous sommes là pour vous aider !",
    info: 'Informations de Contact',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    hours: "Heures d'ouverture",
    monday: 'Lundi - Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche',
    closed: 'Fermé',
    general: 'Demande générale',
    consultation: 'Demander une consultation',
    quote: 'Obtenir un devis de projet',
    success: 'Message envoyé avec succès !',
    successDesc: 'Nous vous répondrons dans les 24 heures.',
    name: 'Nom complet',
    company: 'Entreprise',
    message: 'Message',
    required: 'Requis',
    service: 'Service intéressé',
    projectType: 'Type de projet',
    budget: 'Fourchette de budget',
    timeline: 'Calendrier',
    send: 'Envoyer le message',
    phoneHours: 'Lun-Ven 9h-18h Beyrouth (EET)',
    companyPlaceholder: "Nom de l'entreprise",
    messagePlaceholderGeneral: 'Comment pouvons-nous vous aider ?',
    messagePlaceholderConsultation: 'Parlez-nous de vos défis commerciaux...',
    messagePlaceholderQuote: 'Veuillez décrire les exigences de votre projet...',
    selectService: 'Sélectionner un service...',
    serviceDigitalTransformation: 'Transformation Numérique',
    serviceProcessAutomation: 'Automatisation des processus',
    serviceStrategy: 'Stratégie Numérique',
    serviceChangeManagement: 'Gestion du changement',
    selectProjectType: 'Sélectionner le type de projet...',
    projectWebApp: 'Application Web',
    projectMobileApp: 'Application Mobile',
    projectApi: 'Développement API',
    projectModernization: 'Modernisation de Legacy',
    projectCloud: 'Solutions Cloud',
    selectBudget: 'Sélectionner le budget...',
    selectTimeline: 'Sélectionner le calendrier...',
    timelineAsap: 'Dès que possible',
    timeline1to3: '1-3 mois',
    timeline3to6: '3-6 mois',
    timeline6plus: '6+ mois',
  },

  // Common
  common: {
    loading: 'Chargement...',
    error: "Une erreur s'est produite",
    comingSoon: 'Bientôt disponible...',
  },

  login: {
    welcomeBack: 'Bon retour !',
    signInDesc: 'Connectez-vous pour accéder à votre compte et continuer à gérer vos opérations efficacement.',
    quickAccessTitle: 'Accès rapide à :',
    quickAccess1: 'Tableau de bord & Analyses',
    quickAccess2: 'Ordres de travail & Actifs',
    quickAccess3: 'Gestion du Chatbot',
    quickAccess4: "Collaboration d'équipe",
    quickAccess5: 'Rapports & Insights',
    newUser: 'Nouveau sur mwbTechs ?',
    startTrialPromo: 'Créez votre compte pour démarrer avec mwbTechs.',
    createAccount: 'Créer un compte',
    signIn: 'Se connecter',
    signInSubtitle: 'Entrez vos identifiants pour accéder à votre compte',
    emailAddress: 'Adresse e-mail',
    password: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    rememberMe: 'Se souvenir de moi pendant 30 jours',
    signingIn: 'Connexion en cours...',
    noAccount: "Vous n'avez pas de compte ?",
    startFreeTrial: 'Créer un compte',
    loginFailed: 'Échec de la connexion',
    verificationEmailSent: 'E-mail de vérification envoyé ! Veuillez vérifier votre boîte de réception.',
    resendVerification: "Renvoyer l'e-mail de vérification",
    sending: 'Envoi en cours...',
    twoFactor: 'Authentification à deux facteurs',
    twoFactorDesc: "Entrez le code de votre application d'authentification",
    twoFactorHint: 'Un code de vérification a été demandé pour',
    verificationFailed: 'Échec de la vérification',
    verificationCode: 'Code de vérification',
    authenticatorHint: "Ouvrez votre application d'authentification (Google Authenticator, Authy, etc.) et entrez le code à 6 chiffres.",
    verifying: 'Vérification en cours...',
    verifySignIn: 'Vérifier et se connecter',
    troubleAuth: "Problème avec votre application d'authentification ?",
    contactSupport: 'Contacter le support',
    backToLogin: 'Retour à la connexion',
    enterSixDigit: 'Veuillez entrer un code à 6 chiffres',
    invalidCode: 'Code de vérification invalide. Veuillez réessayer.',
    emailRequired: "L'e-mail est requis",
    invalidEmail: 'Adresse e-mail invalide',
    passwordRequired: 'Le mot de passe est requis',
  },

  signup: {
    title: "Commencez Votre Essai Gratuit Aujourd'hui",
    subtitle: "Rejoignez plus de 2 000 entreprises qui transforment leurs opérations avec mwbTechs",
    benefit1: 'Essai gratuit de 14 jours, aucune carte de crédit requise',
    benefit2: 'Accès à toutes les fonctionnalités',
    benefit3: 'Support prioritaire',
    benefit4: 'Annulez à tout moment',
    includedTitle: 'Ce qui est inclus :',
    included1: 'Accès complet à GMAO ou Chatbot IA',
    included2: "Utilisateurs illimités pendant l'essai",
    included3: "Accès à l'application mobile",
    included4: 'Support par e-mail',
    included5: 'Aucune carte de crédit requise',
    included6: 'Assistance à la configuration incluse',
    stepAccount: 'Créer Votre Compte',
    stepAccountDesc: 'Entrez vos coordonnées pour commencer',
    stepCompany: "Informations sur l'Entreprise",
    stepCompanyDesc: 'Parlez-nous de votre organisation',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'Adresse e-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    trialLabel: "Commencer avec un essai gratuit de 14 jours",
    trialDesc: 'Aucune carte de crédit requise. Accès complet à toutes les fonctionnalités.',
    continue: 'Continuer',
    companyName: "Nom de l'entreprise",
    industry: "Secteur d'activité",
    companySize: "Taille de l'entreprise",
    selectSize: 'Sélectionner la taille',
    small: '1-50 employés',
    medium: '51-250 employés',
    large: '251-1000 employés',
    enterprise: '1000+ employés',
    phone: 'Téléphone',
    country: 'Pays',
    timezone: 'Fuseau horaire',
    selectCountryFirst: "Sélectionnez d'abord un pays",
    servicesInterested: 'Quels services vous intéressent ?',
    cmmsName: 'GMAO',
    cmmsDesc: 'Système de gestion de maintenance',
    chatbotName: 'Chatbot IA',
    chatbotDesc: 'Bot de support client intelligent',
    agreeTerms: "J'accepte les",
    termsOfService: "Conditions d'utilisation",
    and: 'et la',
    privacyPolicy: 'Politique de confidentialité',
    back: 'Retour',
    startFreeTrial: "Démarrer l'Essai Gratuit",
    creatingAccount: 'Création du compte...',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    signIn: 'Se connecter',
    welcomeTitle: 'Bienvenue sur mwbTechs !',
    welcomeDesc: 'Votre compte a été créé avec succès. Vérifiez votre e-mail pour le lien de vérification.',
    goToLogin: 'Aller à la connexion',
    selectService: 'Veuillez sélectionner au moins un service pour continuer.',
    firstNameRequired: 'Le prénom est requis',
    lastNameRequired: 'Le nom de famille est requis',
    emailRequired: "L'e-mail est requis",
    invalidEmail: 'Adresse e-mail invalide',
    passwordRequired: 'Le mot de passe est requis',
    passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
    confirmPasswordRequired: 'Veuillez confirmer le mot de passe',
    passwordsMustMatch: 'Les mots de passe ne correspondent pas',
    companySizeRequired: "La taille de l'entreprise est requise",
    companyNameRequired: "Le nom de l'entreprise est requis",
    acceptTerms: 'Vous devez accepter les conditions',
  },

  auth: {
    verifyEmail: 'Vérifiez Votre E-mail',
    verifyDesc: "Nous avons envoyé un lien de vérification à votre adresse e-mail. Veuillez vérifier votre boîte de réception et cliquer sur le lien pour activer votre compte.",
    verifyNote: "Vous n'avez pas reçu l'e-mail ? Vérifiez votre dossier spam.",
    backToLogin: 'Retour à la connexion',
    verifying: 'Vérification de votre e-mail...',
    verifiedTitle: 'E-mail vérifié !',
    verifiedDesc: 'Votre e-mail a été vérifié avec succès. Vous pouvez maintenant vous connecter à votre compte.',
    goToLogin: 'Aller à la connexion',
    failedTitle: 'Échec de la vérification',
    failedDesc: 'Le lien de vérification est invalide ou a expiré.',
    requestNew: 'Demander un nouveau lien',
    forgotTitle: 'Mot de passe oublié ?',
    forgotDesc: "Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    emailAddress: 'Adresse e-mail',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    sending: 'Envoi en cours…',
    checkEmail: 'Vérifiez votre e-mail',
    checkEmailDesc: "Si un compte existe avec cette adresse e-mail, nous avons envoyé un lien de réinitialisation. Veuillez vérifier votre boîte de réception et votre dossier spam.",
    backToLoginLink: 'Retour à la connexion',
    resetTitle: 'Définir un nouveau mot de passe',
    resetDesc: 'Choisissez un mot de passe fort pour votre compte.',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetButton: 'Réinitialiser le mot de passe',
    resetting: 'Réinitialisation…',
    resetSuccess: 'Mot de passe réinitialisé !',
    resetSuccessDesc: 'Votre mot de passe a été mis à jour avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    invalidResetLink: 'Lien de réinitialisation invalide',
    invalidResetDesc: 'Ce lien de réinitialisation de mot de passe est manquant ou invalide. Veuillez en demander un nouveau.',
    requestNewLink: 'Demander un nouveau lien',
    passwordMin: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordsNoMatch: 'Les mots de passe ne correspondent pas',
  },

  cmmsPage: {
    badge: 'Gestion de la Maintenance',
    heroTitle: 'Solution GMAO Complète pour la Maintenance Moderne',
    heroSubtitle: "Rationalisez vos opérations de maintenance, réduisez les temps d'arrêt et prolongez la durée de vie des actifs avec notre système de gestion de la maintenance complet.",
    startFreeTrial: 'Commencer',
    scheduleDemo: 'Planifier une Démo',
    watchWalkthrough: 'Voir la Présentation',
    videoSectionBadge: 'Présentation du Produit',
    videoSectionTitle: 'Découvrez mwbTechs CMMS en Action',
    videoSectionSubtitle: 'Regardez la présentation complète et voyez comment les équipes gèrent la maintenance dès le premier jour.',
    lessDowntime: "Moins de Temps d'Arrêt",
    fasterResponse: 'Réponse Plus Rapide',
    avgSavings: 'Économies Moyennes',
    featuresTitle: 'Fonctionnalités Puissantes pour un Contrôle Complet de la Maintenance',
    featuresSubtitle: 'Tout ce dont vous avez besoin pour gérer efficacement les opérations de maintenance',
    f1Title: 'Gestion des Actifs',
    f1Desc: "Suivez et gérez tous vos actifs avec des enregistrements détaillés, l'historique de maintenance et le suivi du cycle de vie.",
    f2Title: 'Maintenance Préventive',
    f2Desc: "Planifiez et automatisez la maintenance préventive pour réduire les temps d'arrêt et prolonger la durée de vie des actifs.",
    f3Title: 'Contrôle des Stocks',
    f3Desc: "Gérez l'inventaire des pièces de rechange avec des points de réapprovisionnement automatiques et l'intégration fournisseurs.",
    f4Title: 'Analyses en Temps Réel',
    f4Desc: 'Obtenez des informations instantanées avec des tableaux de bord personnalisables et des rapports complets.',
    f5Title: 'Accès Mobile',
    f5Desc: "Les techniciens peuvent accéder aux bons de travail, mettre à jour les statuts et enregistrer le temps depuis n'importe où.",
    f6Title: 'Gestion des Bons de Travail',
    f6Desc: 'Créez, assignez et suivez les bons de travail avec des niveaux de priorité et des flux de travail automatisés.',
    useCasesTitle: 'Résultats Réels dans Tous les Secteurs',
    useCasesSubtitle: 'Découvrez comment les entreprises transforment leurs opérations de maintenance',
    challenge: 'Défi',
    solution: 'Solution',
    result: 'Résultat',
    uc1Industry: 'Fabrication',
    uc1Challenge: "Temps d'arrêt imprévus coûtant 50 000 $/heure",
    uc1Solution: 'Mise en place de plannings de maintenance prédictive',
    uc1Result: "Réduction de 35% des temps d'arrêt, économies annuelles de 2 M$",
    uc2Industry: 'Gestion des Installations',
    uc2Challenge: 'Bons de travail papier manuels causant des retards',
    uc2Solution: 'Système de bons de travail numérique avec application mobile',
    uc2Result: '60% de temps de réponse plus rapides, réduction des coûts de 40%',
    uc3Industry: 'Santé',
    uc3Challenge: 'Suivi de la conformité et de la sécurité des équipements',
    uc3Solution: 'Suivi automatisé de la conformité et alertes',
    uc3Result: '100% de conformité réglementaire, zéro incident de sécurité',
    uc4Industry: 'Hôtellerie & Hôtels',
    uc4Challenge: 'Gestion des demandes de maintenance dans des centaines de chambres sans perturber les clients',
    uc4Solution: 'Suivi des équipements par chambre avec planification prioritaire et dispatch en temps réel',
    uc4Result: '50% de réduction du temps de réponse aux demandes clients, amélioration notable des scores de satisfaction',
    pricingTitle: 'Choisissez Votre Plan',
    pricingSubtitle: 'Facturation mensuelle ou annuelle • Annulez à tout moment',
    monthly: 'Mensuel',
    annual: 'Annuel',
    save10: 'Économisez 10%',
    custom: 'Personnalisé',
    perMonth: '/mois',
    billedAnnually: 'facturé annuellement',
    getStarted: 'Commencer',
    mostPopular: 'Le Plus Populaire',
    contactPricing: 'Contactez-nous pour les informations tarifaires.',
    getInTouch: 'Nous contacter',
    ctaTitle: 'Prêt à Transformer Vos Opérations de Maintenance ?',
    ctaSubtitle: "Rejoignez 500+ entreprises utilisant notre GMAO pour réduire les coûts et améliorer l'efficacité",
  },

  chatbotPage: {
    badge: 'Support Client Alimenté par IA',
    heroTitle: 'Chatbot Intelligent Qui Comprend Vos Clients',
    heroSubtitle: "Déployez des chatbots IA qui fournissent un support client 24h/24, répondent instantanément aux questions et transfèrent automatiquement vers des agents en direct si nécessaire.",
    tryItFree: 'Essayer Gratuitement',
    seeDemo: 'Voir la Démo',
    watchWalkthrough: 'Voir la Présentation',
    videoSectionBadge: 'Présentation du Produit',
    videoSectionTitle: 'Découvrez mwbTechs Chatbot en Action',
    videoSectionSubtitle: 'Regardez la présentation complète et voyez comment le chatbot gère de vraies conversations clients.',
    benefitsTitle: 'Pourquoi les Entreprises Adorent Notre Chatbot IA',
    b1Label: 'Disponibilité',
    b1Desc: "Ne manquez aucune demande client",
    b2Label: "Taux d'Automatisation",
    b2Desc: 'Gérez automatiquement la plupart des requêtes',
    b3Label: 'Temps de Réponse',
    b3Desc: 'Réponses instantanées, clients satisfaits',
    b4Label: 'Réduction des Coûts',
    b4Desc: 'Réduisez significativement les coûts de support',
    featuresTitle: 'Fonctionnalités Puissantes pour le Support Client Moderne',
    featuresSubtitle: 'Tout ce dont vous avez besoin pour offrir une expérience client exceptionnelle',
    f1Title: 'Intelligence Alimentée par IA',
    f1Desc: "Le NLP avancé comprend le contexte, l'intention et fournit des réponses précises et humaines.",
    f2Title: 'Support Multilingue',
    f2Desc: 'Communiquez avec les clients dans 50+ langues avec traduction automatique.',
    f3Title: 'Formation Instantanée',
    f3Desc: 'Formez votre chatbot sur des documents, sites web et FAQ en quelques minutes.',
    f4Title: 'Analyses des Conversations',
    f4Desc: "Suivez les métriques, identifiez les tendances et améliorez continuellement l'expérience client.",
    f5Title: 'Intégration Facile',
    f5Desc: "Code d'intégration simple pour ajouter le chatbot à votre site web, application ou plateforme en quelques minutes.",
    f6Title: 'Support Omnicanal',
    f6Desc: 'Déployez sur site web, application mobile, WhatsApp, Facebook Messenger, et plus encore.',
    stepsTitle: 'Commencez en 3 Étapes Simples',
    step1Title: 'Formez Votre Chatbot',
    step1Desc: 'Téléversez des documents, ajoutez des URL de sites web ou collez des FAQ. Notre IA apprend instantanément.',
    step2Title: "Personnalisez l'Apparence",
    step2Desc: 'Adaptez votre marque avec des couleurs personnalisées, logo et messages de bienvenue.',
    step3Title: 'Déployez Partout',
    step3Desc: "Ajoutez le code d'intégration à votre site web et soyez en ligne en quelques minutes !",
    pricingTitle: 'Tarification Simple et Transparente',
    pricingSubtitle: 'Facturation mensuelle ou annuelle • Annulez à tout moment',
    monthly: 'Mensuel',
    annual: 'Annuel',
    save10: 'Économisez 10%',
    custom: 'Personnalisé',
    perMonth: '/mois',
    billedAnnually: 'facturé annuellement',
    getStarted: 'Commencer',
    mostPopular: 'Le Plus Populaire',
    contactPricing: 'Contactez-nous pour les informations tarifaires.',
    getInTouch: 'Nous contacter',
    startFreeTrial: 'Commencer',
    planFeatMessages: '{{count}} messages / mois',
    planFeatDocsUnlimited: 'Documents illimités / chatbot',
    planFeatDocs: '{{count}} documents / chatbot',
    planFeatAgentsUnlimited: 'Agents en direct illimités',
    planFeatAgents: '{{count}} agent en direct inclus',
    planFeatAgentsPlural: '{{count}} agents en direct inclus',
    planFeatChannels: 'WhatsApp, Instagram & Facebook',
    liveAgentBadge: 'Support Agent en Direct',
    liveAgentTitle: "L'IA Gère en Premier. Les Humains Interviennent Quand C'est Important.",
    liveAgentSubtitle: "Quand l'IA atteint ses limites, un vrai agent rejoint la conversation — instantanément, avec tout le contexte.",
    liveAgentDesc: "Notre chatbot surveille chaque conversation en temps réel. Quand il ne peut pas résoudre un problème ou que le visiteur demande de l'aide humaine, il déclenche automatiquement un transfert vers votre équipe d'agents. Les agents voient l'historique complet de la conversation, so les clients n'ont jamais à se répéter.",
    liveAgentB1: "Transfert automatique quand l'IA ne peut pas résoudre",
    liveAgentB2: "Les agents voient l'historique complet des conversations",
    liveAgentB3: "Boîte de réception en temps réel pour gérer les chats en direct",
    liveAgentB4: 'Transfert fluide — aucune interruption pour les visiteurs',
    ctaTitle: 'Prêt à Automatiser Votre Support Client ?',
    ctaSubtitle: "Rejoignez les entreprises utilisant des chatbots IA et des agents en direct pour ravir leurs clients",
    seeInAction: 'Voir en Action',
  },

  sfmsPage: {
    badge: 'Gestion des Installations Sportives',
    heroTitle: 'Tous Vos Sites, Adhérents et Dossiers de Réservation dans un Seul Système',
    heroSubtitle: "SFMS regroupe vos dossiers de réservation, abonnements d'académie, adhésions, événements et équipements en un seul endroit, avec des accès par rôle sur l'ensemble de vos sites.",
    requestDemo: 'Demander une Démo',
    seeDashboard: 'Voir le Tableau de Bord',
    talkToSales: 'Parler à un Commercial',
    highlightsTitle: 'Conçu pour les sites de toutes tailles',
    h1: 'Dossiers de réservation pour chaque terrain, court et salle',
    h2: "Abonnements d'académie et adhésions au même endroit",
    h3: 'Plusieurs sites sur un seul compte',
    h4: 'Accès par rôle pour chaque membre du personnel',
    previewTitle: 'SFMS en Action',
    previewSubtitle: 'Un aperçu du tableau de bord que vos équipes utilisent au quotidien',
    previewCaption: 'SFMS — Tableau de Bord',
    previewAlt: 'Tableau de bord SFMS',
    previewPlaceholder: "La capture d'écran du tableau de bord vient ici",
    featuresTitle: 'Tout ce dont Votre Installation a Besoin au Même Endroit',
    featuresSubtitle: "Des dossiers de réservation et abonnements aux rapports d'utilisation",
    f1Title: 'Dossiers de Réservation',
    f1Desc: "Enregistrez et suivez chaque réservation sur vos terrains, courts et salles, avec tout l'historique conservé par espace.",
    f2Title: "Abonnements d'Académie",
    f2Desc: "Inscrivez les adhérents aux programmes de l'académie et tenez à jour sessions, renouvellements et présences.",
    f3Title: 'Gestion des Adhésions',
    f3Desc: "Créez vos formules d'adhésion et gardez en ordre périodes de validité, renouvellements et droits d'accès.",
    f4Title: 'Événements',
    f4Desc: 'Organisez tournois, matchs amicaux et événements ponctuels, et visualisez-les avec vos réservations habituelles.',
    f5Title: 'Inventaire',
    f5Desc: 'Tenez un inventaire léger des équipements et consommables, avec niveaux de stock et mouvements par site.',
    f6Title: 'Rôles & Permissions',
    f6Desc: "Le contrôle d'accès par rôle donne à chaque employé exactement les écrans et les dossiers nécessaires à son poste.",
    f7Title: 'Multi-Sites',
    f7Desc: 'Pilotez plusieurs sites depuis un seul compte, chacun avec ses espaces, son personnel et ses dossiers.',
    f8Title: "Rapports & Taux d'Occupation",
    f8Desc: "Visualisez l'utilisation de chaque espace sur la semaine et ajustez effectifs et horaires selon la demande réelle.",
    ctaTitle: 'Prêt à Gérer Votre Installation depuis un Seul Système ?',
    ctaSubtitle: "Découvrez comment SFMS réunit dossiers de réservation, abonnements et sites.",
  },

  gmsPage: {
    badge: 'Gestion de Salle de Sport',
    heroTitle: 'Gérez Votre Salle sans Paperasse',
    heroSubtitle: "GMS prend en charge les adhésions, les entrées, les plannings de cours et les équipes de coachs au même endroit, pour que votre personnel consacre son temps aux adhérents plutôt qu'aux tableurs.",
    requestDemo: 'Demander une Démo',
    seeDashboard: 'Voir le Tableau de Bord',
    talkToSales: 'Parler à un Commercial',
    highlightsTitle: 'Pensé pour les studios, les salles et les réseaux',
    h1: 'Profils adhérents, formules et renouvellements',
    h2: "Enregistrement rapide à l'accueil ou en autonomie",
    h3: 'Plannings des cours collectifs et du coaching individuel',
    h4: 'Plannings des coachs et affectation des adhérents',
    previewTitle: 'GMS en Action',
    previewSubtitle: 'Un aperçu du tableau de bord que vos équipes utilisent au quotidien',
    previewCaption: 'GMS — Tableau de Bord',
    previewAlt: 'Tableau de bord GMS',
    previewPlaceholder: "La capture d'écran du tableau de bord vient ici",
    featuresTitle: "Tout ce qu'il Faut pour Gérer Votre Salle",
    featuresSubtitle: 'Adhésions, cours, personnel et rapports sur une seule plateforme',
    f1Title: "Formules d'Adhésion",
    f1Desc: 'Créez des formules mensuelles, annuelles ou à la séance, et maîtrisez renouvellements, suspensions et résiliations.',
    f2Title: 'Entrées & Accès',
    f2Desc: "Enregistrez les adhérents à l'accueil ou sur une borne en libre-service, et repérez les adhésions expirées avant leur arrivée.",
    f3Title: 'Planification des Cours',
    f3Desc: "Publiez vos cours collectifs avec limites de capacité, listes d'attente et réservation en autonomie.",
    f4Title: 'Gestion des Coachs',
    f4Desc: "Affectez les coachs aux cours et aux séances individuelles et rendez chaque planning visible par toute l'équipe.",
    f5Title: 'Facturation & Paiements',
    f5Desc: 'Encaissez les paiements récurrents et ponctuels et suivez les soldes dus par adhérent.',
    f6Title: 'Analyse des Adhérents',
    f6Desc: 'Suivez la fréquentation, la fidélisation et la répartition des formules sur des tableaux de bord dédiés.',
    ctaTitle: 'Prêt à Moderniser Votre Salle ?',
    ctaSubtitle: 'Réunissez adhésions, cours et paiements dans un système utilisable par toute votre équipe.',
  },

  pricingPage: {
    heroTitle1: 'Tarification',
    heroTitle2: 'Simple et Transparente',
    heroSubtitle: "Choisissez la formule idéale pour votre entreprise.",
    cmmsPlans: 'Plans GMAO',
    chatbotPlans: 'Plans Chatbot IA',
    monthly: 'Mensuel',
    annual: 'Annuel',
    save10: 'Économisez 10%',
    custom: 'Personnalisé',
    perMonth: '/mois',
    billedAnnually: 'facturé annuellement',
    mostPopular: 'Le Plus Populaire',
    startFreeTrial: 'Commencer',
    contactPricing: 'Contactez-nous pour les informations tarifaires.',
    faqTitle: 'Questions Fréquemment Posées',
    faq1Q: 'Puis-je changer de plan à tout moment ?',
    faq1A: 'Oui ! Vous pouvez mettre à niveau ou rétrograder votre plan à tout moment. Les modifications prennent effet immédiatement.',
    faq2Q: 'Quels modes de paiement acceptez-vous ?',
    faq2A: 'Nous acceptons toutes les principales cartes de crédit (Visa, MasterCard, Amex), PayPal et virements bancaires pour les plans annuels.',
    faq3Q: 'Proposez-vous un essai gratuit ?',
    faq3A: "Nous ne proposons pas d'essai gratuit. Demandez plutôt une démo : nous vous présentons la plateforme avant que vous choisissiez une formule.",
    faq4Q: "Puis-je voir la plateforme avant d'acheter ?",
    faq4A: 'Oui. Demandez une démo et nous vous ferons une présentation adaptée à votre usage prévu.',
    faq5Q: 'Proposez-vous des remboursements ?',
    faq5A: 'Oui, nous offrons une garantie de remboursement de 30 jours sur tous les plans.',
    faq6Q: 'Puis-je obtenir un plan personnalisé ?',
    faq6A: "Absolument ! Contactez notre équipe commerciale pour des solutions entreprise sur mesure adaptées à vos besoins.",
    ctaTitle: 'Prêt à Commencer ?',
    ctaSubtitle: 'Demandez une démo et nous vous aiderons à choisir la bonne formule.',
    contactSales: 'Contacter les Ventes',
  },

  docsPage: {
    title: 'Documentation',
    subtitle: 'Tout ce dont vous avez besoin pour tirer le meilleur de mwbTechs',
    searchPlaceholder: 'Rechercher dans la documentation...',
    s1Title: 'Premiers Pas',
    s1Desc: 'Guides de démarrage rapide et ressources de prise en main',
    s1l1: 'Installation',
    s1l2: 'Premières Étapes',
    s1l3: 'Configuration de Base',
    s1l4: 'Tutoriels',
    s2Title: 'Guide Chatbot',
    s2Desc: 'Créez, configurez et intégrez votre chatbot IA',
    s2l1: 'Créer un Chatbot',
    s2l2: 'Base de Connaissances & RAG',
    s2l3: 'Intégration Web',
    s2l4: 'Intégration Application Mobile',
    s2l5: 'Intégration API REST',
    s2l6: 'Configuration Canal WhatsApp',
    s2l7: 'Configuration Canal Messenger',
    s2l8: 'Configuration Canal Instagram',
    s3Title: 'Guide GMAO',
    s3Desc: 'Configurez et gérez vos opérations de maintenance',
    s3l1: 'Premiers Pas',
    s3l2: 'Gestion des Actifs',
    s3l3: 'Bons de Travail',
    s3l4: 'Maintenance Préventive',
    s3l5: 'Équipe & Permissions',
    s4Title: 'Tutoriels Vidéo',
    s4Desc: 'Démonstrations vidéo étape par étape',
    s4l1: 'Tour Rapide',
    s4l2: 'Fonctionnalités Avancées',
    s4l3: 'Meilleures Pratiques',
    s4l4: 'Dépannage',
    needHelpTitle: "Besoin d'Aide Supplémentaire ?",
    needHelpSubtitle: "Notre équipe de support est là pour vous aider",
    visitHelp: "Visiter le Centre d'Aide",
    contactSupport: 'Contacter le Support',
  },

  dtPage: {
    badge: 'Conseil Stratégique',
    heroTitle: 'Transformation Numérique Qui Génère de Vrais Résultats',
    heroSubtitle: 'Naviguez dans le changement numérique avec confiance. Nous aidons les organisations à moderniser leurs opérations, adopter la technologie et atteindre une croissance durable.',
    scheduleConsultation: 'Planifier une Consultation',
    ourApproach: 'Notre Approche',
    stat1Label: 'Transformations Réalisées',
    stat2Label: 'Satisfaction Client',
    stat3Label: 'Valeur Moyenne Créée',
    stat4Label: "Années d'Expérience",
    servicesTitle: 'Services Complets de Transformation Numérique',
    servicesSubtitle: 'Accompagnement de bout en bout pour votre parcours numérique',
    keyDeliverables: 'Livrables Clés :',
    s1Title: 'Stratégie & Évaluation',
    s1Desc: "Évaluez l'état actuel, identifiez les opportunités et développez une feuille de route de transformation numérique complète.",
    s1d1: 'Évaluation de la maturité numérique',
    s1d2: 'Analyse des lacunes technologiques',
    s1d3: 'Feuille de route stratégique',
    s1d4: 'Projections de ROI',
    s2Title: 'Optimisation des Processus',
    s2Desc: 'Rationalisez les opérations, éliminez les inefficacités et automatisez les flux de travail manuels.',
    s2d1: 'Cartographie des processus',
    s2d2: "Opportunités d'automatisation",
    s2d3: 'Conception des flux de travail',
    s2d4: 'Cadre KPI',
    s3Title: 'Mise en Œuvre Technologique',
    s3Desc: 'Déployez des solutions modernes, intégrez des systèmes et migrez vers une infrastructure cloud.',
    s3d1: 'Sélection des systèmes',
    s3d2: "Planification de l'intégration",
    s3d3: 'Migration cloud',
    s3d4: 'Programmes de formation',
    methodologyTitle: 'Notre Méthodologie Éprouvée',
    methodologySubtitle: 'Une approche structurée qui donne des résultats',
    p1Phase: '1. Découverte',
    p1Duration: '2-3 semaines',
    p1a1: 'Entretiens avec les parties prenantes',
    p1a2: "Analyse de l'état actuel",
    p1a3: 'Alignement des objectifs',
    p1a4: 'Identification des points de douleur',
    p2Phase: '2. Stratégie',
    p2Duration: '3-4 semaines',
    p2a1: 'Feuille de route numérique',
    p2a2: 'Sélection technologique',
    p2a3: 'Plan de gestion du changement',
    p2a4: 'Budget et calendrier',
    p3Phase: '3. Mise en Œuvre',
    p3Duration: '8-12 semaines',
    p3a1: 'Déploiement de la solution',
    p3a2: 'Intégration des systèmes',
    p3a3: 'Migration des données',
    p3a4: 'Formation des utilisateurs',
    p4Phase: '4. Optimisation',
    p4Duration: 'Continu',
    p4a1: 'Surveillance des performances',
    p4a2: 'Amélioration continue',
    p4a3: 'Support utilisateur',
    p4a4: 'Suivi du ROI',
    caseStudiesTitle: 'Histoires de Succès',
    caseStudiesSubtitle: 'Transformations réelles, résultats mesurables',
    challenge: 'Défi',
    solution: 'Solution',
    results: 'Résultats',
    cs1Company: 'Manufacturing Corp',
    cs1Industry: 'Fabrication',
    cs1Challenge: 'Processus papier causant des retards et des erreurs',
    cs1Solution: "Automatisation des flux de travail numériques et intégration IoT",
    cs1r1: 'Traitement des commandes 70% plus rapide',
    cs1r2: "Réduction des erreurs de 90%",
    cs1r3: '1,5 M$ économies annuelles',
    cs1r4: 'Augmentation de la productivité de 40%',
    cs2Company: 'Retail Chain',
    cs2Industry: 'Commerce de Détail',
    cs2Challenge: 'Systèmes déconnectés et mauvaise connaissance client',
    cs2Solution: "Plateforme de commerce unifiée et tableau de bord analytique",
    cs2r1: 'Vue client à 360°',
    cs2r2: 'Augmentation des ventes de 25%',
    cs2r3: 'Inventaire en temps réel',
    cs2r4: 'Paiement 50% plus rapide',
    cs3Company: 'Financial Services',
    cs3Industry: 'Finance',
    cs3Challenge: "Systèmes legacy limitant l'innovation et l'agilité",
    cs3Solution: "Migration cloud et architecture API-first",
    cs3r1: 'Vitesse de déploiement multipliée par 10',
    cs3r2: 'Réduction des coûts de 60%',
    cs3r3: 'Zéro temps d\'arrêt',
    cs3r4: 'Infrastructure évolutive',
    ctaTitle: 'Prêt à Transformer Votre Entreprise ?',
    ctaSubtitle: 'Planifiez une consultation gratuite pour discuter de votre parcours de transformation numérique',
    scheduleFreeConsultation: 'Planifier une Consultation Gratuite',
    expertConsultants: 'Consultants Experts',
    successRate: 'Taux de Réussite',
    avgValueCreated: 'ROI Driven Results',
  },

  cdPage: {
    badge: 'Développement Personnalisé',
    heroTitle: 'Construisez des Logiciels Qui Évoluent avec Votre Entreprise',
    heroSubtitle: "Équipe de développement experte prête à transformer votre vision en réalité. Du MVP aux solutions entreprise.",
    requestQuote: 'Demander un Devis',
    viewPortfolio: 'Voir le Portfolio',
    stat1Title: '200+ Projets Livrés',
    stat1Sub: 'Dans 15+ secteurs',
    stat2Title: '98% Satisfaction Client',
    stat2Sub: 'Basé sur 150+ avis',
    stat3Title: 'Démarrage en 4 Semaines en Moyenne',
    stat3Sub: 'Du contrat au développement',
    servicesTitle: 'Services de Développement Complets',
    servicesSubtitle: 'Développement de bout en bout avec des technologies modernes',
    s1Title: 'Applications Web',
    s1Desc: 'Applications web personnalisées construites avec des frameworks modernes pour la scalabilité et les performances.',
    s2Title: 'Développement Mobile',
    s2Desc: 'Applications iOS/Android natives ou solutions multi-plateformes pour une portée maximale.',
    s3Title: 'Solutions Cloud',
    s3Desc: "Architecture cloud évolutive et services de migration pour une infrastructure moderne.",
    s4Title: 'Développement API',
    s4Desc: 'APIs RESTful et GraphQL pour une intégration système transparente.',
    s5Title: 'Sécurité & Conformité',
    s5Desc: 'Sécurité de niveau entreprise avec des normes de conformité intégrées.',
    s6Title: 'Optimisation des Performances',
    s6Desc: 'Accélérez les applications existantes et optimisez pour la montée en charge.',
    processTitle: 'Notre Processus de Développement',
    processSubtitle: 'Méthodologie agile avec des résultats prouvés',
    pr1Step: 'Découverte',
    pr1Desc: 'Comprendre les exigences, objectifs et contraintes techniques',
    pr1Duration: '1-2 semaines',
    pr1d1: 'Document des exigences',
    pr1d2: 'Spécifications techniques',
    pr1d3: 'Calendrier du projet',
    pr1d4: 'Estimation des coûts',
    pr2Step: 'Conception',
    pr2Desc: "Créer l'architecture, les designs UX/UI et la feuille de route de développement",
    pr2Duration: '2-3 semaines',
    pr2d1: 'Architecture système',
    pr2d2: 'Maquettes UI/UX',
    pr2d3: 'Schéma de base de données',
    pr2d4: "Conception de l'API",
    pr3Step: 'Développement',
    pr3Desc: "Construire la solution avec des sprints agiles et l'intégration continue",
    pr3Duration: '8-16 semaines',
    pr3d1: 'Logiciel fonctionnel',
    pr3d2: 'Revues de code',
    pr3d3: 'Démos de sprint',
    pr3d4: 'Documentation',
    pr4Step: 'Tests',
    pr4Desc: 'QA complète, tests de sécurité et optimisation des performances',
    pr4Duration: '2-3 semaines',
    pr4d1: 'Rapports de tests',
    pr4d2: 'Corrections de bugs',
    pr4d3: 'Métriques de performance',
    pr4d4: 'Audit de sécurité',
    pr5Step: 'Déploiement',
    pr5Desc: 'Déploiement en production avec surveillance et support',
    pr5Duration: '1 semaine',
    pr5d1: 'Application en direct',
    pr5d2: 'Documentation de déploiement',
    pr5d3: 'Configuration de la surveillance',
    pr5d4: 'Formation',
    pr6Step: 'Support',
    pr6Desc: 'Maintenance continue, mises à jour et améliorations de fonctionnalités',
    pr6Duration: 'Continu',
    pr6d1: 'Corrections de bugs',
    pr6d2: 'Mises à jour',
    pr6d3: 'Nouvelles fonctionnalités',
    pr6d4: 'Support 24/7',
    portfolioTitle: 'Projets Récents',
    portfolioSubtitle: 'Solutions réelles que nous avons construites pour de vraies entreprises',
    pf1Title: 'Anatolia Gold Catalogue',
    pf1Desc: 'Back-office et application mobile pour les boutiques de détail en or, ainsi qu\'une application usine où les commandes clients sont assignées aux employés selon le stade de fabrication',
    pf2Title: 'Dr. Kashmar',
    pf2Desc: 'Système de gestion multi-cliniques pour la dermatologie cosmétique en Arabie Saoudite et à Beyrouth, avec un portail back-office et une application mobile native iOS & Android',
    pf3Title: 'Intégration Bridge MT5',
    pf3Desc: 'Intégration bridge MetaTrader 5 sur mesure permettant une connectivité fluide entre les courtiers et l\'infrastructure de trading',
    investmentTitle: "Fourchettes d'Investissement",
    investmentSubtitle: 'Tarification transparente pour chaque taille de projet',
    pl1Name: 'Développement MVP',
    pl1Desc: 'Parfait pour les startups et les preuves de concept',
    pl2Name: 'Produit Complet',
    pl2Desc: 'Solution complète pour les entreprises en croissance',
    pl3Name: 'Entreprise',
    pl3Desc: 'Solutions à grande échelle avec équipe dédiée',
    mostPopular: 'Le Plus Populaire',
    getQuote: 'Obtenir un Devis',
    ctaTitle: 'Prêt à Construire Votre Solution Personnalisée ?',
    ctaSubtitle: 'Discutons de votre projet et créons quelque chose de remarquable ensemble',
    requestFreeQuote: 'Demander un Devis Gratuit',
  },

  aboutPage: {
    heroTitle1: "Transformer les Entreprises grâce à l'",
    heroTitle2: 'Innovation',
    heroSubtitle: "Notre mission est d'aider les entreprises à moderniser leurs opérations avec des solutions logicielles intelligentes qui produisent de véritables résultats.",
    getInTouch: 'Nous Contacter',
    startFreeTrial: 'Commencer',
    stat1Label: 'Clients dans le Monde',
    stat2Label: 'Utilisateurs Actifs',
    stat3Label: 'Satisfaction Client',
    stat4Label: 'Support Disponible',
    storyTitle: 'Notre Histoire',
    storyP1: 'Fondée en 2018, mwbTechs a démarré avec une observation simple : les entreprises peinaient avec des systèmes de gestion de maintenance obsolètes qui freinaient la productivité et augmentaient les coûts.',
    storyP2: "Nos fondateurs, une équipe d'ingénieurs et de dirigeants d'entreprise avec des décennies d'expérience combinée, ont vu une opportunité de révolutionner la façon dont les entreprises gèrent leurs opérations. Nous avons construit notre première solution CMMS en mettant l'accent sur la simplicité, la puissance et l'expérience utilisateur.",
    storyP3: "Aujourd'hui, nous servons plus de 2 000 entreprises dans le monde entier, des petites équipes aux sociétés du Fortune 500. Nous avons élargi nos offres pour inclure des chatbots alimentés par l'IA, des conseils en transformation numérique et des services de développement sur mesure.",
    storyP4: "Mais notre mission principale reste la même : aider les entreprises à fonctionner plus efficacement grâce à des solutions technologiques innovantes.",
    countriesServed: 'Pays Desservis',
    industryAwards: 'Prix Industriels',
    teamMembers: "Membres de l'Équipe",
    yoyGrowth: 'Croissance Annuelle',
    valuesTitle: 'Nos Valeurs',
    valuesSubtitle: 'Les principes qui guident tout ce que nous faisons',
    v1Title: "Innovation d'Abord",
    v1Desc: 'Nous repoussons constamment les limites pour livrer des solutions de pointe qui créent une réelle valeur commerciale.',
    v2Title: 'Succès Client',
    v2Desc: "Votre succès est notre succès. Nous nous engageons à vous aider à atteindre vos objectifs.",
    v3Title: 'Collaboration',
    v3Desc: "Nous croyons au pouvoir du travail d'équipe, tant en interne qu'avec nos clients.",
    v4Title: 'Excellence',
    v4Desc: 'Nous maintenons les plus hauts standards dans tout ce que nous faisons, du code au service client.',
    teamTitle: 'Équipe de Direction',
    teamSubtitle: "Des dirigeants expérimentés passionnés par l'innovation",
    timelineTitle: 'Notre Parcours',
    timelineSubtitle: 'Les étapes clés de notre histoire de croissance',
    m1Event: "Fondation de l'Entreprise",
    m1Desc: 'Démarré avec une vision pour transformer la gestion de la maintenance',
    m2Event: 'Premiers 100 Clients',
    m2Desc: 'Atteint le jalon de 100 clients satisfaits dans 10 industries',
    m3Event: 'Financement Série A',
    m3Desc: 'Levée de 10 millions de dollars pour accélérer le développement produit',
    m4Event: 'Lancement du Chatbot IA',
    m4Desc: "Lancement d'une solution révolutionnaire de support client alimentée par l'IA",
    m5Event: 'Expansion Mondiale',
    m5Desc: 'Expansion des opérations en Europe et en Asie-Pacifique',
    m6Event: '1 000+ Clients',
    m6Desc: 'Franchi le cap de 1 000 clients avec un taux de satisfaction de 98%',
    m7Event: 'Reconnaissance Industrielle',
    m7Desc: 'Nommé Leader dans le Magic Quadrant de Gartner',
    m8Event: 'Croissance Continue',
    m8Desc: "Servant plus de 2 000 entreprises dans le monde avec 50 000+ utilisateurs actifs",
    ctaTitle: 'Rejoignez Notre Aventure',
    ctaSubtitle: 'Faites partie du futur des opérations commerciales',
    contactUs: 'Nous Contacter',
  },
  chatbotDocs: {
    breadcrumb: 'Documentation',
    title: 'Guide d\'intégration du Chatbot',
    heroSubtitle: 'Créez votre chatbot IA, construisez sa base de connaissances et intégrez-le sur votre site web ou application mobile — étape par étape.',
    onThisPage: 'Sur cette page',
    toc_create: 'Créer un Chatbot',
    toc_kb: 'Base de connaissances & RAG',
    toc_website: 'Intégration Web',
    toc_mobile: 'Intégration Mobile',
    toc_api: 'Intégration REST API',
    toc_whatsapp: 'Configuration WhatsApp',
    toc_messenger: 'Configuration Messenger',
    toc_instagram: 'Configuration Instagram',
    s1_title: 'Créer un Chatbot',
    s1_subtitle: 'Configurez votre chatbot dans le Portail Client en quelques minutes.',
    s1_step1: 'Connectez-vous au Portail Client et accédez à la section Chatbot depuis la barre latérale.',
    s1_step2: 'Cliquez sur «Créer un nouveau Chatbot» et renseignez les informations de base.',
    s1_step3: 'Configurez les paramètres d\'apparence et de comportement :',
    s1_field: 'Champ',
    s1_fieldDesc: 'Description',
    s1_fname: 'Nom',
    s1_fnameDesc: 'Libellé interne pour ce chatbot',
    s1_fBotName: 'Nom du Bot',
    s1_fBotNameDesc: 'Nom affiché aux visiteurs',
    s1_fWelcome: 'Message de bienvenue',
    s1_fWelcomeDesc: 'Premier message que le visiteur voit à l\'ouverture du chat',
    s1_fPrompt: 'System Prompt',
    s1_fPromptDesc: 'Instructions définissant la personnalité et le périmètre de l\'IA',
    s1_fColor: 'Couleur principale',
    s1_fColorDesc: 'Couleur d\'accentuation pour le widget de chat (code hex)',
    s1_fPosition: 'Position',
    s1_fPositionDesc: 'Emplacement du widget : bas-droite ou bas-gauche',
    s1_note: 'Après l\'enregistrement, votre ID Chatbot et le code d\'intégration vous seront affichés. Gardez l\'ID Chatbot à portée — vous en aurez besoin pour les étapes d\'intégration ci-dessous.',
    s2_title: 'Base de connaissances & RAG',
    s2_subtitle: 'Alimentez votre chatbot avec des documents, des pages web et des données API en direct.',
    s2_intro: 'Ouvrez la fenêtre Base de connaissances du chatbot (icône engrenage → Base de connaissances). Vous pouvez ajouter du contenu depuis trois sources :',
    s2_docs: 'Documents téléchargés',
    s2_docsDesc: 'Téléchargez des fichiers PDF, DOCX ou TXT. La plateforme extrait le texte, le découpe en morceaux et stocke des embeddings vectoriels pour que l\'IA puisse retrouver les passages pertinents.',
    s2_docsSupported: 'Formats supportés : PDF, DOCX, TXT, HTML',
    s2_urls: 'URLs de sites web',
    s2_urlsDesc: 'Collez une URL et la plateforme explore et indexe automatiquement le texte de la page. Utile pour les pages produits, les FAQ ou les articles de blog.',
    s2_apis: 'APIs externes',
    s2_apisDesc: 'Connectez des REST APIs en direct (ex. votre inventaire e-commerce). Lorsqu\'un visiteur pose une question pertinente, le chatbot appelle votre API en temps réel et répond à partir de la réponse JSON actualisée.',
    s2_configFields: 'Champs de configuration',
    s2_afName: 'Nom',
    s2_afNameDesc: 'Un libellé court, ex. «Recherche Produits»',
    s2_afDesc: 'Description',
    s2_afDescDesc: 'Indique à l\'IA quand utiliser cette API, ex. «Utiliser quand le visiteur demande des produits ou des prix»',
    s2_afEndpoint: 'URL Endpoint',
    s2_afEndpointDesc: 'URL complète ; ajoutez {query} pour la recherche, ou omettez-le pour récupérer la liste complète',
    s2_afAuthName: 'Nom de l\'en-tête d\'auth',
    s2_afAuthNameDesc: 'Optionnel — ex. X-Shopify-Access-Token',
    s2_afAuthValue: 'Valeur de l\'en-tête d\'auth',
    s2_afAuthValueDesc: 'Optionnel — stocké chiffré AES-256',
    s2_urlExamples: 'Exemples d\'URLs',
    s2_note: 'Utilisez «Tester & Enregistrer» pour vérifier que l\'endpoint est accessible avant de sauvegarder. Jusqu\'à 5 APIs externes par chatbot.',
    s3_title: 'Intégration Web',
    s3_subtitle: 'Ajoutez le widget de chat sur n\'importe quel site avec une seule balise script.',
    s3_step1: 'Copiez votre ID Chatbot depuis le Portail Client (visible sur la carte du chatbot ou dans la section intégration).',
    s3_step2: 'Collez la balise script ci-dessous dans votre HTML, juste avant la balise </body> fermante.',
    s3_step3: 'Ajustez les attributs data-* pour correspondre aux paramètres de votre chatbot.',
    s3_attrRef: 'Référence des attributs',
    s3_attrAttr: 'Attribut',
    s3_attrRequired: 'Requis',
    s3_attrDesc: 'Description',
    s3_attr1Req: '✅ Oui',
    s3_attr1Desc: 'Identifiant unique de votre chatbot',
    s3_attr2Req: '✅ Oui',
    s3_attr2Desc: 'URL de base du backend chatbot',
    s3_attr3Req: 'Optionnel',
    s3_attr3Desc: 'Couleur d\'accent du widget en hex (#007bff)',
    s3_attr4Req: 'Optionnel',
    s3_attr4Desc: 'bas-droite (défaut) ou bas-gauche',
    s3_attr5Req: 'Optionnel',
    s3_attr5Desc: 'Message d\'ouverture affiché au visiteur',
    s3_attr6Req: 'Optionnel',
    s3_attr6Desc: 'Nom d\'affichage de l\'assistant IA',
    s4_title: 'Intégration Mobile',
    s4_subtitle: 'Intégrez le widget de chat dans une application React Native avec WebView.',
    s4_step1: 'Installez le package WebView :',
    s4_step2: 'Créez un composant ChatbotWidget. Remplacez YOUR_CHATBOT_ID et your-platform.com par vos valeurs.',
    s4_step3: 'Montez le composant à la racine de votre application (dans votre provider d\'auth pour qu\'il n\'apparaisse qu\'une fois connecté) :',
    s4_platformNotes: 'Notes par plateforme',
    s4_pAndroid: 'Émulateur Android',
    s4_pAndroidDesc: 'Utilisez 10.0.2.2 à la place de localhost (l\'émulateur mappe 10.0.2.2 → votre machine)',
    s4_pDevice: 'Appareil physique',
    s4_pDeviceDesc: 'Utilisez l\'IP LAN de votre machine (ex. 192.168.1.x) pour que l\'appareil puisse atteindre votre serveur de dev',
    s4_pIOS: 'Simulateur iOS',
    s4_pIOSDesc: 'localhost fonctionne directement',
    s4_pProd: 'Production',
    s4_pProdDesc: 'Utilisez votre vrai domaine HTTPS — aucune modification nécessaire',
    s5_title: 'Intégration REST API',
    s5_subtitle: 'Appelez l\'API de chat directement depuis n\'importe quel backend, application mobile ou interface personnalisée — sans widget.',
    s5_intro: 'Chaque chatbot expose le même endpoint REST. Deux méthodes d\'authentification sont prises en charge : la Clé Widget (en-tête X-Widget-Key, sûre pour le widget navigateur) et une Clé API secrète (en-tête Authorization: Bearer, pour les intégrations côté serveur). Générez la Clé API depuis les paramètres du chatbot dans le Portail Client.',
    s5_auth: 'Authentification',
    s5_authDesc: 'Choisissez la méthode adaptée : X-Widget-Key pour le widget intégré, ou Authorization: Bearer <api-key> pour les intégrations personnalisées côté serveur (générez la clé dans les paramètres du chatbot).',
    s5_sendMsg: 'Envoyer un message',
    s5_reqHeaders: 'En-têtes de la requête',
    s5_reqBody: 'Corps de la requête (JSON)',
    s5_field: 'Champ',
    s5_required: 'Requis',
    s5_fSessionIdDesc: 'Identifiant de conversation unique — générez un UUID par conversation',
    s5_fMessageDesc: 'Le texte du message de l\'utilisateur',
    s5_fVisitorIdDesc: 'Votre identifiant utilisateur/visiteur interne',
    s5_fVisitorEmailDesc: 'E-mail du visiteur — stocké sur l\'enregistrement de conversation',
    s5_fVisitorNameDesc: 'Nom d\'affichage du visiteur',
    s5_fMediaUrlDesc: 'URL d\'un fichier média à joindre au message (image, audio, document)',
    s5_fChannelTypeDesc: '«WIDGET» (par défaut) ou «WHATSAPP» — identifie le canal d\'envoi',
    s5_fChannelSenderIdDesc: 'ID expéditeur WhatsApp (wa_id) — requis quand channelType vaut «WHATSAPP»',
    s5_codeExamples: 'Exemples de code',
    s5_response: 'Réponse',
    s5_endConv: 'Terminer une conversation',
    s5_endConvDesc: 'Appelez ceci quand l\'utilisateur ferme le chat pour marquer la session comme terminée.',
    s5_note: 'La Clé Widget est publique et sûre pour le code navigateur. La Clé API (Bearer token) est réservée à l\'usage côté serveur — gardez-la secrète et ne l\'incluez jamais dans le code frontend ou application mobile.',
    s6_title: 'Configuration du canal WhatsApp',
    s6_subtitle: 'Acheminez les messages WhatsApp Business via votre chatbot IA et vos agents en direct.',
    s6_intro: 'L\'intégration WhatsApp utilise l\'API Meta WhatsApp Business (Cloud API). Vous connectez votre propre compte Meta Business — Meta vous facture directement les frais de conversation au-delà du niveau gratuit.',
    s6_prereqs: 'Prérequis',
    s6_p1: 'Compte Meta Business',
    s6_p1Desc: 'Un compte Meta Business Manager vérifié sur business.facebook.com',
    s6_p2: 'Application Meta Developer',
    s6_p2Desc: 'Une application Meta avec le produit WhatsApp Business API ajouté (developers.facebook.com)',
    s6_p3: 'Numéro de téléphone vérifié',
    s6_p3Desc: 'Un numéro WhatsApp Business ajouté et vérifié dans votre application Meta',
    s6_p4: 'Token d\'accès permanent',
    s6_p4Desc: 'Un token d\'accès d\'utilisateur système avec la permission whatsapp_business_messaging',
    s6_step1Title: 'Étape 1 — Ajouter un canal dans le Portail',
    s6_step1_1: 'Dans le Portail Client, ouvrez votre chatbot et faites défiler jusqu\'à la section Canaux WhatsApp.',
    s6_step1_2: 'Cliquez sur «Ajouter un canal» et renseignez les quatre champs :',
    s6_fField: 'Champ',
    s6_fWhere: 'Où le trouver',
    s6_fDispName: 'Nom d\'affichage',
    s6_fDispNameDesc: 'N\'importe quel libellé, ex. «Support Client WhatsApp»',
    s6_fPhoneId: 'ID du numéro de téléphone',
    s6_fPhoneIdDesc: 'Application Meta → WhatsApp → Configuration API → Phone Number ID',
    s6_fToken: 'Token d\'accès',
    s6_fTokenDesc: 'Application Meta → Utilisateurs système → votre utilisateur → Générer un token (stocké chiffré)',
    s6_fWebhookToken: 'Token de vérification Webhook',
    s6_fWebhookTokenDesc: 'Une chaîne secrète de votre invention — vous saisirez la même valeur dans Meta',
    s6_step1Note: 'Après l\'enregistrement, le portail affiche votre URL Webhook. Copiez-la — vous en aurez besoin à l\'étape suivante.',
    s6_step2Title: 'Étape 2 — Configurer le Webhook dans Meta',
    s6_step2_1: 'Dans votre tableau de bord d\'application Meta, allez dans WhatsApp → Configuration.',
    s6_step2_2: 'Sous Webhook, cliquez Modifier et saisissez l\'URL Webhook copiée depuis le portail.',
    s6_step2_3: 'Saisissez votre Token de vérification Webhook (la même chaîne qu\'à l\'étape 1).',
    s6_step2_4: 'Cliquez sur «Vérifier et enregistrer». Meta appellera votre webhook pour confirmer qu\'il répond correctement.',
    s6_step2_5: 'Abonnez-vous à l\'événement webhook «messages» pour que Meta vous envoie les messages entrants.',
    s6_howTitle: 'Comment ça fonctionne',
    s6_how1: 'Un client envoie un message à votre numéro WhatsApp Business.',
    s6_how2: 'Meta livre le message à votre URL Webhook.',
    s6_how3: 'Le chatbot le traite via le même pipeline IA utilisé par le widget du site.',
    s6_how4: 'La réponse de l\'IA est renvoyée au client via l\'API Graph de Meta.',
    s6_how5: 'Si le chatbot déclenche un transfert vers un agent, la conversation apparaît dans la Boîte de réception en direct. Quand l\'agent répond, le message est automatiquement transmis au client via WhatsApp.',
    s6_billing: 'Facturation : Meta offre 1 000 conversations de service gratuites par mois par compte WhatsApp Business. Au-delà, Meta facture par conversation selon votre pays. Ces frais sont facturés directement sur votre compte Meta Business — pas via cette plateforme.',
    s7_title: 'Configuration du canal Messenger',
    s7_subtitle: 'Connectez votre Page Facebook pour recevoir et répondre aux conversations Messenger via votre chatbot IA et vos agents en direct.',
    s7_intro: 'L\'intégration Messenger utilise l\'API Meta Messenger Platform. Vous connectez une Page Facebook que vous gérez — votre chatbot reçoit les messages envoyés à cette page via Messenger.',
    s7_prereqs: 'Prérequis',
    s7_p1: 'Compte Meta Business',
    s7_p1Desc: 'Un compte Meta Business Manager vérifié sur business.facebook.com',
    s7_p2: 'Page Facebook',
    s7_p2Desc: 'Une Page Facebook que vous administrez (la page que les utilisateurs contactent)',
    s7_p3: 'Application Meta Developer',
    s7_p3Desc: 'Une application Meta avec le produit Messenger ajouté (developers.facebook.com)',
    s7_p4: 'Token d\'accès à la Page',
    s7_p4Desc: 'Un token d\'accès permanent à la Page avec la permission pages_messaging',
    s7_step1Title: 'Étape 1 — Ajouter un canal dans le Portail',
    s7_step1_1: 'Dans le Portail Client, ouvrez votre chatbot et faites défiler jusqu\'à la section Canaux de messagerie.',
    s7_step1_2: 'Cliquez sur l\'onglet Messenger, puis sur «Ajouter un canal» et renseignez les quatre champs :',
    s7_fField: 'Champ',
    s7_fWhere: 'Où le trouver',
    s7_fDispName: 'Nom d\'affichage',
    s7_fDispNameDesc: 'N\'importe quel libellé, ex. «Messenger Entreprise»',
    s7_fPageId: 'ID de Page Facebook',
    s7_fPageIdDesc: 'Votre Page Facebook → À propos → ID de Page (numérique)',
    s7_fToken: 'Token d\'accès',
    s7_fTokenDesc: 'Application Meta → Messenger → Configuration API → Générer un token (stocké chiffré)',
    s7_fWebhookToken: 'Token de vérification Webhook',
    s7_fWebhookTokenDesc: 'Une chaîne secrète de votre invention — vous saisirez la même valeur dans Meta',
    s7_step2Title: 'Étape 2 — Configurer le Webhook dans Meta',
    s7_step2_1: 'Dans votre tableau de bord d\'application Meta, allez dans Messenger → Paramètres → Webhooks.',
    s7_step2_2: 'Cliquez Modifier et saisissez l\'URL Webhook copiée depuis le portail.',
    s7_step2_3: 'Saisissez votre Token de vérification Webhook (la même chaîne qu\'à l\'étape 1).',
    s7_step2_4: 'Abonnez-vous au champ messages et cliquez «Vérifier et enregistrer».',
    s7_step2_5: 'Sous Abonnements, ajoutez votre Page Facebook pour qu\'elle utilise ce webhook.',
    s7_howTitle: 'Comment ça fonctionne',
    s7_how1: 'Un client envoie un message à votre Page Facebook via Messenger.',
    s7_how2: 'Meta livre le message à votre URL Webhook.',
    s7_how3: 'Le chatbot le traite via le même pipeline IA utilisé par le widget du site.',
    s7_how4: 'La réponse de l\'IA est renvoyée au client via l\'API Graph de Meta.',
    s7_how5: 'Si le chatbot déclenche un transfert vers un agent, la conversation apparaît dans la Boîte de réception en direct. Quand l\'agent répond, le message est automatiquement transmis au client via Messenger.',
    s7_billing: 'Facturation : L\'API Messenger est actuellement gratuite pour la messagerie standard. Meta pourrait introduire des frais à l\'avenir. Tout frais est facturé directement sur votre compte Meta Business — pas via cette plateforme.',
    s8_title: 'Configuration du canal Instagram',
    s8_subtitle: 'Connectez votre compte Instagram Business pour recevoir et répondre aux messages directs Instagram via votre chatbot IA et vos agents en direct.',
    s8_intro: 'L\'intégration des DM Instagram utilise l\'API Meta Instagram Messaging. Votre compte Instagram Business doit être connecté à une Page Facebook dans Meta Business Suite.',
    s8_prereqs: 'Prérequis',
    s8_p1: 'Compte Instagram Business',
    s8_p1Desc: 'Un compte Instagram converti en compte Business ou Créateur',
    s8_p2: 'Page Facebook liée',
    s8_p2Desc: 'Le compte Instagram doit être connecté à une Page Facebook dans Meta Business Suite',
    s8_p3: 'Application Meta Developer',
    s8_p3Desc: 'Une application Meta avec le produit Instagram Messaging ajouté',
    s8_p4: 'Token d\'accès à la Page',
    s8_p4Desc: 'Un token d\'accès permanent à la Page Facebook liée avec la permission instagram_manage_messages',
    s8_step1Title: 'Étape 1 — Ajouter un canal dans le Portail',
    s8_step1_1: 'Dans le Portail Client, ouvrez votre chatbot et faites défiler jusqu\'à la section Canaux de messagerie.',
    s8_step1_2: 'Cliquez sur l\'onglet Instagram, puis sur «Ajouter un canal» et renseignez les quatre champs :',
    s8_fField: 'Champ',
    s8_fWhere: 'Où le trouver',
    s8_fDispName: 'Nom d\'affichage',
    s8_fDispNameDesc: 'N\'importe quel libellé, ex. «Instagram Entreprise»',
    s8_fAccountId: 'ID du compte Instagram',
    s8_fAccountIdDesc: 'Application Meta → Instagram → Configuration API → Instagram Business Account ID (numérique)',
    s8_fToken: 'Token d\'accès',
    s8_fTokenDesc: 'Token d\'accès à la Page Facebook liée (stocké chiffré)',
    s8_fWebhookToken: 'Token de vérification Webhook',
    s8_fWebhookTokenDesc: 'Une chaîne secrète de votre invention — vous saisirez la même valeur dans Meta',
    s8_step2Title: 'Étape 2 — Configurer le Webhook dans Meta',
    s8_step2_1: 'Dans votre tableau de bord d\'application Meta, allez dans Instagram → Paramètres → Webhooks.',
    s8_step2_2: 'Cliquez Modifier et saisissez l\'URL Webhook copiée depuis le portail.',
    s8_step2_3: 'Saisissez votre Token de vérification Webhook (la même chaîne qu\'à l\'étape 1).',
    s8_step2_4: 'Abonnez-vous au champ messages et cliquez «Vérifier et enregistrer».',
    s8_step2_5: 'Assurez-vous que votre compte Instagram Business est lié à la Page abonnée.',
    s8_howTitle: 'Comment ça fonctionne',
    s8_how1: 'Un client envoie un message direct à votre compte Instagram Business.',
    s8_how2: 'Meta livre le message à votre URL Webhook.',
    s8_how3: 'Le chatbot le traite via le même pipeline IA utilisé par le widget du site.',
    s8_how4: 'La réponse de l\'IA est renvoyée au client via l\'API Graph de Meta.',
    s8_how5: 'Si le chatbot déclenche un transfert vers un agent, la conversation apparaît dans la Boîte de réception en direct. Quand l\'agent répond, le message est automatiquement transmis au client via DM Instagram.',
    s8_note: 'Remarque : l\'automatisation des DM Instagram nécessite l\'approbation de l\'App Review de Meta pour la permission instagram_manage_messages. Testez avec vos propres comptes pendant le développement. Tout frais Meta est facturé directement sur votre compte Meta Business.',
    needHelp: 'Besoin d\'aide ?',
    needHelpSubtitle: 'Notre équipe de support est prête à vous aider avec votre intégration.',
    backToDocs: '← Retour à la Documentation',
    contactSupport: 'Contacter le support',
  },
  cmmsDocs: {
    breadcrumb: 'Documentation',
    breadcrumbPage: 'Guide CMMS',
    title: 'Guide utilisateur CMMS',
    heroSubtitle: 'Configurez votre système de gestion de maintenance, gérez les équipements, planifiez la maintenance préventive et gardez votre équipe alignée — étape par étape.',
    onThisPage: 'Sur cette page',
    toc_start: 'Démarrage',
    toc_assets: 'Gestion des équipements',
    toc_wo: 'Bons de travail',
    toc_pm: 'Maintenance préventive',
    toc_inv: 'Inventaire & Entrepôts',
    toc_team: 'Équipe & Permissions',
    toc_reports: 'Rapports & Analyses',
    s1_title: 'Démarrage',
    s1_subtitle: 'Connectez-vous au Portail Client et activez votre abonnement CMMS.',
    s1_step1: 'Connectez-vous au Portail Client et accédez à Produits.',
    s1_step2: 'Sélectionnez le plan CMMS adapté à la taille de votre équipe et cliquez Souscrire.',
    s1_step3: 'Une fois actif, la section CMMS apparaît dans la barre latérale gauche.',
    s1_step4: 'Allez dans CMMS → Tableau de bord pour une vue d\'ensemble de vos opérations.',
    s1_keyConcepts: 'Concepts clés',
    s1_branch: 'Branch',
    s1_branchDesc: 'Un site physique ou un établissement où votre entreprise opère (ex. une usine ou un bureau)',
    s1_asset: 'Équipement',
    s1_assetDesc: 'Tout équipement ou élément que vous souhaitez suivre et entretenir',
    s1_wo: 'Bon de travail',
    s1_woDesc: 'Une tâche assignée à un technicien pour réparer ou entretenir un équipement',
    s1_pm: 'Programme de maintenance',
    s1_pmDesc: 'Une tâche de maintenance récurrente qui s\'exécute automatiquement selon un calendrier',
    s1_inv: 'Inventaire',
    s1_invDesc: 'Pièces de rechange et matériaux stockés dans vos entrepôts',
    s2_title: 'Gestion des équipements',
    s2_subtitle: 'Enregistrez et suivez tous les équipements dans vos branches.',
    s2_step1: 'Accédez à CMMS → Équipements et cliquez Ajouter un équipement.',
    s2_step2: 'Renseignez les détails de l\'équipement — nom, catégorie, branch et emplacement.',
    s2_step3: 'Ajoutez optionnellement des composants (sous-pièces) avec leurs propres intervalles de maintenance.',
    s2_step4: 'Joignez des photos, manuels ou documents de garantie si nécessaire.',
    s2_step5: 'Enregistrez l\'équipement. Il est maintenant traçable et peut être lié à des bons de travail.',
    s2_assetFields: 'Champs de l\'équipement',
    s2_fField: 'Champ',
    s2_fDesc: 'Description',
    s2_fName: 'Nom',
    s2_fNameDesc: 'Nom lisible de l\'équipement (ex. Compresseur d\'air n°3)',
    s2_fCode: 'Code équipement',
    s2_fCodeDesc: 'Référence interne unique (ex. AC-003)',
    s2_fCategory: 'Catégorie',
    s2_fCategoryDesc: 'Type d\'équipement — Électrique, Mécanique, CVC, etc.',
    s2_fBranch: 'Branch',
    s2_fBranchDesc: 'Le site auquel appartient cet équipement',
    s2_fLocation: 'Emplacement',
    s2_fLocationDesc: 'Salle ou zone spécifique dans la branch',
    s2_fSerial: 'Numéro de série',
    s2_fSerialDesc: 'Numéro de série fabricant pour le suivi de garantie',
    s2_fPurchase: 'Date d\'achat',
    s2_fPurchaseDesc: 'Utilisée pour calculer l\'âge de l\'équipement et le statut de garantie',
    s2_fNextService: 'Prochaine maintenance',
    s2_fNextServiceDesc: 'Date planifiée pour la prochaine visite de maintenance',
    s2_note: 'Les équipements dont les composants sont à remplacer apparaissent en surbrillance dans le tableau de bord CMMS pour ne jamais manquer une fenêtre de maintenance.',
    s3_title: 'Bons de travail',
    s3_subtitle: 'Créez, assignez et suivez les tâches de maintenance.',
    s3_step1: 'Allez dans CMMS → Bons de travail et cliquez Créer un bon de travail.',
    s3_step2: 'Sélectionnez l\'équipement, décrivez le problème et définissez la priorité (Faible / Moyen / Élevé / Critique).',
    s3_step3: 'Assignez-le à un technicien de votre équipe.',
    s3_step4: 'Définissez une date de fin estimée.',
    s3_step5: 'Le technicien assigné reçoit une notification et peut mettre à jour le statut au fur et à mesure.',
    s3_step6: 'Une fois résolu, le technicien marque le bon comme Terminé et ajoute une note de service.',
    s3_statuses: 'Statuts des bons de travail',
    s3_open: 'Ouvert',
    s3_openDesc: 'Nouvellement créé, pas encore commencé',
    s3_inProgress: 'En cours',
    s3_inProgressDesc: 'Le technicien travaille dessus',
    s3_onHold: 'En attente',
    s3_onHoldDesc: 'En attente de pièces ou d\'approbation',
    s3_completed: 'Terminé',
    s3_completedDesc: 'Travail terminé et vérifié',
    s4_title: 'Maintenance préventive',
    s4_subtitle: 'Automatisez la maintenance récurrente pour prévenir les pannes.',
    s4_step1: 'Allez dans CMMS → Programmes PM et cliquez Ajouter un programme.',
    s4_step2: 'Sélectionnez l\'équipement et décrivez la tâche de maintenance (ex. Vidange).',
    s4_step3: 'Définissez la fréquence — Quotidienne, Hebdomadaire, Mensuelle, Trimestrielle ou Annuelle.',
    s4_step4: 'Assignez un technicien par défaut pour gérer cette tâche.',
    s4_step5: 'Enregistrez. Le système générera automatiquement un bon de travail à chaque date d\'échéance.',
    s4_note: 'Les programmes PM dus dans les 7 prochains jours sont mis en évidence sur le widget du tableau de bord CMMS pour que votre équipe puisse se préparer à l\'avance.',
    s5_title: 'Inventaire & Entrepôts',
    s5_subtitle: 'Suivez les pièces de rechange et matériaux dans tous vos lieux de stockage.',
    s5_step1: 'Créez des entrepôts sous CMMS → Entrepôts (chaque entrepôt appartient à une branch).',
    s5_step2: 'Ajoutez des articles d\'inventaire sous CMMS → Inventaire — définissez le nom, l\'unité, la quantité et le stock minimum.',
    s5_step3: 'Assignez chaque article à un entrepôt.',
    s5_step4: 'Lorsqu\'un bon de travail est terminé, le technicien enregistre les pièces utilisées — le stock se décrémente automatiquement.',
    s5_note: 'Les articles en dessous de leur stock minimum sont signalés dans le tableau de bord pour que vous puissiez réapprovisionner avant la rupture.',
    s6_title: 'Équipe & Permissions',
    s6_subtitle: 'Invitez des membres et contrôlez ce que chaque rôle peut voir et faire.',
    s6_step1: 'Allez dans CMMS → Équipe et cliquez Inviter un membre.',
    s6_step2: 'Saisissez l\'adresse e-mail du membre et sélectionnez son rôle.',
    s6_step3: 'L\'invité reçoit un e-mail avec un lien pour configurer son compte.',
    s6_step4: 'Une fois connecté, il ne voit que les sections autorisées par son rôle.',
    s6_roles: 'Rôles CMMS',
    s6_roleCol: 'Rôle',
    s6_accessCol: 'Niveau d\'accès',
    s6_admin: 'Administrateur',
    s6_adminDesc: 'Accès complet — peut gérer l\'équipe, les équipements, les bons de travail, les rapports et les paramètres',
    s6_supervisor: 'Superviseur',
    s6_supervisorDesc: 'Voir et gérer tous les bons de travail ; peut créer des programmes PM ; pas d\'accès à la facturation',
    s6_technician: 'Technicien',
    s6_technicianDesc: 'Voir et mettre à jour les bons de travail qui lui sont assignés ; pas d\'accès à la gestion',
    s6_viewer: 'Observateur',
    s6_viewerDesc: 'Accès en lecture seule aux équipements et bons de travail à des fins d\'audit',
    s7_title: 'Rapports & Analyses',
    s7_subtitle: 'Mesurez les performances de maintenance et identifiez les tendances.',
    s7_intro: 'Accédez à CMMS → Rapports pour consulter les analyses intégrées. Les rapports peuvent être exportés en PDF ou Excel.',
    s7_r1: 'Résumé des bons de travail',
    s7_r1Desc: 'Total des bons de travail par statut (Ouvert / En cours / Terminé), délai moyen de résolution et nombre de retards.',
    s7_r2: 'Rapport de santé des équipements',
    s7_r2Desc: 'Liste de tous les équipements avec la date de dernière maintenance, la prochaine maintenance planifiée et les bons de travail ouverts.',
    s7_r3: 'Performance des techniciens',
    s7_r3Desc: 'Bons de travail terminés par technicien, délai moyen de résolution et missions en retard.',
    s7_r4: 'Conformité PM',
    s7_r4Desc: 'Pourcentage de tâches de maintenance préventive terminées dans les délais par rapport aux retards sur toutes les branches.',
    s7_r5: 'Utilisation de l\'inventaire',
    s7_r5Desc: 'Pièces consommées par période, niveaux de stock et articles approchant du seuil minimum.',
    needHelp: 'Besoin d\'aide ?',
    needHelpSubtitle: 'Notre équipe de support est prête à vous aider avec la configuration de votre CMMS.',
    backToDocs: '← Retour à la Documentation',
    contactSupport: 'Contacter le support',
  },

  // Help Page
  helpPage: {
    title: "Centre d'Aide",
    subtitle: "Trouvez des réponses et obtenez de l'aide",
    getInTouch: 'Nous Contacter',
    faqTitle: 'Questions Fréquentes',
    stillNeedHelp: "Besoin d'aide supplémentaire ?",
    stillNeedHelpDesc: 'Notre équipe de support est disponible 24h/24, 7j/7 pour vous aider',
    contactSupport: 'Contacter le Support',
    contact1Title: 'Chat en Direct',
    contact1Desc: 'Discutez avec notre équipe de support en temps réel',
    contact1Action: 'Démarrer le Chat',
    contact1Available: 'Disponible 24h/24',
    contact2Title: 'Support par E-mail',
    contact2Desc: 'Nous répondrons dans les 24 heures',
    contact2Action: 'Envoyer un E-mail',
    contact2Available: 'support@mwbtechs.com',
    contact3Title: 'Support Téléphonique',
    contact3Desc: 'Appelez-nous pour une assistance immédiate',
    contact3Action: 'Appeler Maintenant',
    contact3Available: '+1 (555) 123-4567',
    contact4Title: 'Documentation',
    contact4Desc: 'Parcourez nos guides complets et tutoriels',
    contact4Action: 'Voir la Documentation',
    contact4Available: 'Ressources en libre-service',
    faq1Cat: 'Démarrage',
    faq1q1: 'Comment créer un compte ?',
    faq1a1: "Cliquez sur le bouton « Commencer » et suivez le processus d'inscription.",
    faq1q2: "Puis-je voir la plateforme avant d'acheter ?",
    faq1a2: 'Oui. Demandez une démo depuis la page de contact et nous vous la présenterons.',
    faq1q3: 'Proposez-vous un essai gratuit ?',
    faq1a3: "Non. Nous proposons plutôt une démo guidée, pour que vous voyiez la plateforme en action avant de choisir une formule.",
    faq2Cat: 'Facturation',
    faq2q1: 'Comment puis-je changer mon forfait ?',
    faq2a1: 'Vous pouvez mettre à niveau ou rétrograder votre forfait à tout moment depuis les paramètres de votre compte.',
    faq2q2: 'Quels modes de paiement acceptez-vous ?',
    faq2a2: 'Nous acceptons toutes les principales cartes de crédit, PayPal et les virements bancaires pour les plans annuels.',
    faq2q3: 'Proposez-vous des remboursements ?',
    faq2a3: 'Oui, nous offrons une garantie de remboursement de 30 jours sur tous les nouveaux abonnements.',
    faq3Cat: 'Fonctionnalités',
    faq3q1: 'Puis-je importer mes données existantes ?',
    faq3a1: "Oui, nous supportons l'importation de données depuis des fichiers CSV et d'autres systèmes GMAO.",
    faq3q2: 'Existe-t-il une application mobile ?',
    faq3a2: 'Oui, nous avons des applications mobiles pour iOS et Android.',
    faq3q3: "Puis-je intégrer avec d'autres outils ?",
    faq3a3: 'Oui, nous proposons des intégrations avec des outils populaires et une API robuste.',
  },

  privacy: {
    pageTitle: 'Politique de confidentialité | mwbTechs',
    metaDesc: 'Lisez la politique de confidentialité de mwbTechs. Découvrez comment nous collectons, utilisons et protégeons vos informations personnelles.',
    title: 'Politique de confidentialité',
    subtitle: 'Votre vie privée est importante pour nous',
    lastUpdated: 'Dernière mise à jour : 22 janvier 2026',
    introTitle: 'Introduction',
    introText: "mwbTechs (« nous », « notre » ou « nos ») s'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre site web et nos services. Veuillez lire attentivement cette politique de confidentialité. Si vous n'êtes pas d'accord avec ses termes, veuillez ne pas accéder au site ni utiliser nos services.",
    ctaTitle: 'Des questions sur la confidentialité ?',
    ctaDesc: 'Notre équipe est là pour vous aider. Contactez-nous à tout moment pour toute question relative à la confidentialité.',
    ctaBtn: "Contacter l'équipe chargée de la confidentialité",
    relTermsTitle: "Conditions d'utilisation",
    relTermsDesc: 'Lire nos conditions générales',
    relCookiesTitle: 'Politique de cookies',
    relCookiesDesc: 'En savoir plus sur notre utilisation des cookies',
    relSecurityTitle: 'Sécurité',
    relSecurityDesc: 'Comment nous protégeons vos données',
    s1Title: '1. Informations que nous collectons',
    s1Content: `<p class="mb-4">Nous collectons les informations que vous nous fournissez directement, notamment :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>Informations de compte :</strong> Nom, adresse e-mail, nom de l'entreprise et mot de passe lors de la création d'un compte</li><li><strong>Informations de profil :</strong> Informations supplémentaires que vous choisissez de fournir dans votre profil</li><li><strong>Informations de paiement :</strong> Coordonnées bancaires et informations de carte de paiement (traitées de manière sécurisée par nos prestataires de paiement)</li><li><strong>Communications :</strong> Informations que vous fournissez lorsque vous nous contactez ou participez à des enquêtes</li><li><strong>Données d'utilisation :</strong> Informations sur la façon dont vous utilisez nos services, y compris les données de journal, les informations sur l'appareil et les cookies</li></ul>`,
    s2Title: '2. Comment nous utilisons vos informations',
    s2Content: `<p class="mb-4">Nous utilisons les informations collectées pour :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Fournir, maintenir et améliorer nos services</li><li>Traiter les transactions et envoyer les informations correspondantes</li><li>Envoyer des avis techniques, des mises à jour, des alertes de sécurité et des messages d'assistance</li><li>Répondre à vos commentaires, questions et fournir un service client</li><li>Surveiller et analyser les tendances, l'utilisation et les activités</li><li>Détecter, prévenir et résoudre les problèmes techniques et les activités frauduleuses</li><li>Personnaliser et améliorer votre expérience</li><li>Envoyer des communications marketing (avec votre consentement)</li></ul>`,
    s3Title: '3. Partage et divulgation des informations',
    s3Content: `<p class="mb-4">Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos informations uniquement dans les circonstances suivantes :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>Avec votre consentement :</strong> Nous partagerons des informations avec votre consentement explicite</li><li><strong>Prestataires de services :</strong> Nous pouvons partager des informations avec des prestataires tiers qui effectuent des services en notre nom</li><li><strong>Exigences légales :</strong> Nous pouvons divulguer des informations si la loi l'exige ou en réponse à des demandes légales</li><li><strong>Transferts d'entreprise :</strong> Les informations peuvent être transférées dans le cadre d'une fusion, d'une acquisition ou d'une vente d'actifs</li><li><strong>Protection des droits :</strong> Pour protéger les droits, la propriété et la sécurité de mwbTechs, de nos utilisateurs et du public</li></ul>`,
    s4Title: '4. Sécurité des données',
    s4Content: `<p class="mb-4">Nous prenons très au sérieux la sécurité de vos informations et mettons en œuvre des mesures techniques et organisationnelles appropriées pour les protéger :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Chiffrement des données en transit et au repos selon des protocoles standard du secteur</li><li>Évaluations régulières de la sécurité et tests d'intrusion</li><li>Contrôles d'accès et mécanismes d'authentification</li><li>Formation des employés sur la protection des données et les pratiques de sécurité</li><li>Procédures de réponse aux incidents et protocoles de notification des violations</li></ul><p class="mb-4">Cependant, aucune méthode de transmission sur Internet ou de stockage électronique n'est sécurisée à 100 %, et nous ne pouvons pas garantir une sécurité absolue.</p>`,
    s5Title: '5. Conservation des données',
    s5Content: `<p class="mb-4">Nous conservons vos informations personnelles aussi longtemps que nécessaire pour :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Vous fournir nos services</li><li>Respecter nos obligations légales</li><li>Résoudre les litiges et appliquer nos accords</li></ul><p class="mb-4">Lorsque nous n'avons plus besoin de vos informations, nous les supprimons ou les anonymisons de manière sécurisée.</p>`,
    s6Title: '6. Vos droits et choix',
    s6Content: `<p class="mb-4">Vous disposez de certains droits concernant vos informations personnelles :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>Accès :</strong> Demander l'accès aux informations personnelles que nous détenons vous concernant</li><li><strong>Rectification :</strong> Demander la correction d'informations inexactes ou incomplètes</li><li><strong>Suppression :</strong> Demander la suppression de vos informations personnelles</li><li><strong>Portabilité :</strong> Demander une copie de vos informations dans un format portable</li><li><strong>Désinscription :</strong> Vous désabonner des communications marketing à tout moment</li><li><strong>Cookies :</strong> Contrôler les cookies via les paramètres de votre navigateur</li></ul><p class="mb-4">Pour exercer ces droits, veuillez nous contacter à privacy@mwbtechs.com.</p>`,
    s7Title: '7. Cookies et technologies de suivi',
    s7Content: `<p class="mb-4">Nous utilisons des cookies et des technologies de suivi similaires pour collecter et suivre des informations sur votre utilisation de nos services. Vous pouvez contrôler les cookies via les paramètres de votre navigateur. Pour plus d'informations, consultez notre <a href="/cookies" class="text-primary-600 hover:underline">Politique de cookies</a>.</p>`,
    s8Title: '8. Transferts internationaux de données',
    s8Content: `<p class="mb-4">Vos informations peuvent être transférées et traitées dans des pays autres que votre pays de résidence. Nous veillons à ce que des mesures de protection appropriées soient en place pour protéger vos informations conformément à cette politique de confidentialité.</p>`,
    s9Title: '9. Confidentialité des enfants',
    s9Content: `<p class="mb-4">Nos services ne sont pas destinés aux enfants de moins de 16 ans. Nous ne collectons pas sciemment d'informations personnelles auprès d'enfants de moins de 16 ans. Si vous pensez que nous avons collecté des informations auprès d'un enfant de moins de 16 ans, veuillez nous contacter immédiatement.</p>`,
    s10Title: '10. Modifications de cette politique de confidentialité',
    s10Content: `<p class="mb-4">Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous vous informerons de tout changement important en publiant la nouvelle politique de confidentialité sur cette page et en mettant à jour la date de « Dernière mise à jour ». Nous vous encourageons à consulter régulièrement cette politique de confidentialité.</p>`,
    s11Title: '11. Nous contacter',
    s11Content: `<p class="mb-4">Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter :</p><ul class="list-none space-y-2"><li><strong>E-mail :</strong> privacy@mwbtechs.com</li><li><strong>Adresse :</strong> 123 Tech Street, San Francisco, CA 94105, États-Unis</li><li><strong>Téléphone :</strong> +1 (555) 123-4567</li></ul>`,
  },

  terms: {
    pageTitle: "Conditions d'utilisation | mwbTechs",
    metaDesc: "Lisez les conditions d'utilisation de mwbTechs. Comprenez les termes et conditions d'utilisation de nos services.",
    title: "Conditions d'utilisation",
    subtitle: "Veuillez lire attentivement ces conditions avant d'utiliser nos services",
    lastUpdated: 'Dernière mise à jour : 22 janvier 2026',
    introTitle: 'Accord sur les conditions',
    introText: "Ces conditions d'utilisation constituent un accord juridiquement contraignant entre vous et mwbTechs concernant votre utilisation de notre site web et de nos services. En accédant ou en utilisant nos services, vous reconnaissez avoir lu, compris et accepté d'être lié par ces conditions.",
    ctaTitle: 'Des questions sur ces conditions ?',
    ctaDesc: 'Notre équipe juridique est disponible pour répondre à toutes vos questions.',
    ctaBtn: "Contacter l'équipe juridique",
    relPrivacyTitle: 'Politique de confidentialité',
    relPrivacyDesc: 'Comment nous protégeons vos données',
    relCookiesTitle: 'Politique de cookies',
    relCookiesDesc: 'En savoir plus sur notre utilisation des cookies',
    relSecurityTitle: 'Sécurité',
    relSecurityDesc: 'Nos pratiques de sécurité',
    s1Title: "1. Acceptation des conditions",
    s1Content: `<p class="mb-4">En accédant et en utilisant les services mwbTechs, vous acceptez d'être lié par ces conditions d'utilisation et notre politique de confidentialité. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.</p>`,
    s2Title: '2. Description des services',
    s2Content: `<p class="mb-4">mwbTechs fournit :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Un logiciel GMAO (Gestion de Maintenance Assistée par Ordinateur)</li><li>Des solutions de chatbot alimentées par l'IA</li><li>Des services de conseil en transformation numérique</li><li>Des services de développement de logiciels sur mesure</li><li>Des services d'assistance et de maintenance associés</li></ul><p class="mb-4">Nous nous réservons le droit de modifier, suspendre ou interrompre toute partie de nos services à tout moment avec un préavis raisonnable.</p>`,
    s3Title: '3. Inscription au compte',
    s3Content: `<p class="mb-4">Pour utiliser nos services, vous devez :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Avoir au moins 18 ans ou l'âge de la majorité dans votre juridiction</li><li>Fournir des informations exactes, actuelles et complètes lors de l'inscription</li><li>Maintenir et mettre à jour rapidement les informations de votre compte</li><li>Garder votre mot de passe sécurisé et confidentiel</li><li>Nous informer immédiatement de toute utilisation non autorisée de votre compte</li></ul><p class="mb-4">Vous êtes responsable de toutes les activités qui se déroulent sous votre compte.</p>`,
    s4Title: '4. Abonnement et facturation',
    s4Content: `<p class="mb-4"><strong>4.1 Essai gratuit :</strong> Nous offrons un essai gratuit de 14 jours aux nouveaux clients. Aucune carte de crédit n'est requise pour démarrer un essai. Vous pouvez annuler à tout moment pendant la période d'essai.</p><p class="mb-4"><strong>4.2 Abonnements payants :</strong> Après la période d'essai, vous serez facturé selon le plan sélectionné (mensuel ou annuel). Les frais ne sont pas remboursables sauf si la loi l'exige ou comme indiqué explicitement dans ces conditions.</p><p class="mb-4"><strong>4.3 Renouvellement automatique :</strong> Les abonnements se renouvellent automatiquement sauf annulation avant la date de renouvellement. Vous serez facturé en utilisant votre mode de paiement sélectionné.</p><p class="mb-4"><strong>4.4 Changements de prix :</strong> Nous pouvons modifier nos tarifs avec un préavis de 30 jours. Les changements prendront effet à votre prochaine date de renouvellement.</p><p class="mb-4"><strong>4.5 Remboursements :</strong> Nous offrons une garantie de remboursement de 30 jours pour les nouveaux abonnements payants. Contactez-nous dans les 30 jours suivant votre premier paiement pour un remboursement complet.</p>`,
    s5Title: "5. Utilisation acceptable",
    s5Content: `<p class="mb-4">Vous acceptez de ne pas :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Utiliser nos services à des fins illégales ou en violation de toute loi</li><li>Télécharger, transmettre ou distribuer du code nuisible, des virus ou des logiciels malveillants</li><li>Tenter d'obtenir un accès non autorisé à nos systèmes ou aux comptes d'autres utilisateurs</li><li>Interférer avec ou perturber l'intégrité ou les performances de nos services</li><li>Utiliser nos services pour envoyer des spams ou des communications non sollicitées</li><li>Scraper, copier ou effectuer de la rétro-ingénierie sur nos services</li><li>Revendre ou redistribuer nos services sans autorisation</li><li>Utiliser nos services d'une manière qui pourrait nuire à notre réputation</li></ul>`,
    s6Title: '6. Propriété intellectuelle',
    s6Content: `<p class="mb-4"><strong>6.1 Notre propriété intellectuelle :</strong> Tout le contenu, les fonctionnalités et les caractéristiques de nos services appartiennent à mwbTechs et sont protégés par les lois sur le droit d'auteur, les marques et autres lois sur la propriété intellectuelle.</p><p class="mb-4"><strong>6.2 Votre contenu :</strong> Vous conservez la propriété de tout contenu que vous soumettez à nos services. En soumettant du contenu, vous nous accordez une licence pour l'utiliser, le stocker et l'afficher dans la mesure nécessaire à la fourniture de nos services.</p><p class="mb-4"><strong>6.3 Retours d'information :</strong> Tout commentaire, suggestion ou idée que vous fournissez devient notre propriété et peut être utilisé sans compensation ni attribution.</p>`,
    s7Title: '7. Données et confidentialité',
    s7Content: `<p class="mb-4">Nous collectons et traitons vos données comme décrit dans notre <a href="/privacy" class="text-primary-600 hover:underline">Politique de confidentialité</a>. Vous êtes responsable de vous assurer que vous avez le droit de soumettre des données à nos services.</p><p class="mb-4">Nous mettons en œuvre des mesures de sécurité standard du secteur, mais ne pouvons pas garantir une sécurité absolue. Vous utilisez nos services à vos propres risques.</p>`,
    s8Title: '8. Contrat de niveau de service (SLA)',
    s8Content: `<p class="mb-4">Nous nous efforçons de maintenir une disponibilité de 99,9 % pour nos services, en dehors de la maintenance planifiée. Les détails de notre SLA sont disponibles dans votre contrat de service ou sur demande pour les clients Enterprise.</p>`,
    s9Title: '9. Garanties et clauses de non-responsabilité',
    s9Content: `<p class="mb-4"><strong>9.1 Services « en l'état » :</strong> Nos services sont fournis « en l'état » et « selon disponibilité » sans garantie d'aucune sorte, expresse ou implicite.</p><p class="mb-4"><strong>9.2 Absence de garantie :</strong> Nous ne garantissons pas que nos services seront ininterrompus, sans erreur ou totalement sécurisés.</p><p class="mb-4"><strong>9.3 Services tiers :</strong> Nous ne sommes pas responsables des services ou intégrations tiers que vous pourriez utiliser avec nos services.</p>`,
    s10Title: '10. Limitation de responsabilité',
    s10Content: `<p class="mb-4">Dans la mesure maximale permise par la loi :</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>mwbTechs ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs</li><li>Notre responsabilité totale ne dépassera pas le montant que vous nous avez payé au cours des 12 mois précédant la réclamation</li><li>Nous ne sommes pas responsables de la perte de données, de profits ou d'opportunités commerciales</li></ul>`,
    s11Title: '11. Indemnisation',
    s11Content: `<p class="mb-4">Vous acceptez d'indemniser et de dégager de toute responsabilité mwbTechs pour toute réclamation, dommage ou dépense découlant de votre utilisation de nos services, de la violation de ces conditions ou de la violation des droits d'une autre partie.</p>`,
    s12Title: '12. Résiliation',
    s12Content: `<p class="mb-4"><strong>12.1 Par vous :</strong> Vous pouvez annuler votre abonnement à tout moment via les paramètres de votre compte ou en nous contactant.</p><p class="mb-4"><strong>12.2 Par nous :</strong> Nous pouvons suspendre ou résilier votre compte si vous violez ces conditions, ne payez pas les frais, ou pour toute autre cause raisonnable avec un préavis approprié.</p><p class="mb-4"><strong>12.3 Effets de la résiliation :</strong> Dès la résiliation, votre droit d'utiliser nos services cesse immédiatement. Nous pouvons supprimer vos données après un délai raisonnable.</p>`,
    s13Title: '13. Droit applicable',
    s13Content: `<p class="mb-4">Ces conditions seront régies par les lois de l'État de Californie, États-Unis, sans égard à ses dispositions en matière de conflits de lois. Tout litige sera résolu devant les tribunaux du comté de San Francisco, Californie.</p>`,
    s14Title: '14. Modifications des conditions',
    s14Content: `<p class="mb-4">Nous pouvons mettre à jour ces conditions de temps à autre. Nous vous informerons des changements importants par e-mail ou via nos services. Votre utilisation continue après les modifications constitue une acceptation des nouvelles conditions.</p>`,
    s15Title: '15. Coordonnées',
    s15Content: `<p class="mb-4">Pour toute question concernant ces conditions, contactez-nous :</p><ul class="list-none space-y-2"><li><strong>E-mail :</strong> legal@mwbtechs.com</li><li><strong>Adresse :</strong> 123 Tech Street, San Francisco, CA 94105, États-Unis</li><li><strong>Téléphone :</strong> +1 (555) 123-4567</li></ul>`,
  },

  security: {
    pageTitle: 'Sécurité | mwbTechs',
    metaDesc: 'Découvrez les pratiques de sécurité de mwbTechs et comment nous protégeons vos données.',
    title: 'Sécurité',
    subtitle: 'Une sécurité de niveau entreprise pour protéger vos données',
    m1Title: 'Chiffrement',
    m1Desc: 'Toutes les données sont chiffrées en transit (TLS 1.3) et au repos (AES-256) selon les protocoles standards du secteur.',
    m2Title: 'Infrastructure Sécurisée',
    m2Desc: 'Hébergé sur une infrastructure cloud de niveau entreprise avec conformité SOC 2 Type II et audits de sécurité réguliers.',
    m3Title: 'Contrôles d\'Accès',
    m3Desc: 'Authentification multi-facteurs, contrôle d\'accès basé sur les rôles et journalisation complète des audits.',
    m4Title: 'Tests Réguliers',
    m4Desc: 'Analyse continue des vulnérabilités, tests de pénétration et évaluations de sécurité par des experts tiers.',
    certTitle: 'Certifications & Conformité',
    cert1: 'Certifié SOC 2 Type II',
    cert2: 'Conforme RGPD',
    cert3: 'Certifié ISO 27001',
    cert4: 'Conforme HIPAA (Entreprise)',
    cert5: 'Conforme PCI DSS',
    reportTitle: 'Signaler des Problèmes de Sécurité',
    reportDesc: 'Si vous découvrez une vulnérabilité de sécurité, veuillez nous la signaler immédiatement à security@mwbtechs.com. Nous prenons tous les rapports de sécurité au sérieux et répondrons rapidement.',
    reportBtn: 'Signaler un Problème',
    relPrivacyTitle: 'Politique de Confidentialité',
    relTermsTitle: 'Conditions d\'Utilisation',
  },

};

export default fr;
